import { Component, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { IAppointmentData, IExportexcelWorklist } from 'src/app/models/IAppointmentDetails';
import { SchedularServiceService } from 'src/app/Services/Schedular/schedular-service.service';
import { IVisitTypes } from 'src/app/models/IVisitTypes';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IRoomsInfo } from 'src/app/models/IRoomsInfo';
import { ILocationDetails } from 'src/app/models/ILocationDetails';
import { Guid } from "guid-typescript";
import { AppComponent } from 'src/app/app.component';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';
import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { Defaults } from 'src/app/Utilities/defaults';
import { IAlerts } from 'src/app/models/IAlerts';
import { DateAdapter, MatDialog, MatSidenav } from '@angular/material';
import { PopupAlertsComponent } from 'src/app/ChildControls/popup-alerts/popup-alerts.component';
import { WarningDialogComponent, warningDialogModel } from 'src/app/ChildControls/warning-dialog/warning-dialog.component';
import { Router, ActivatedRoute } from '@angular/router';
import { IprocedureCode, IProcedureCodes } from 'src/app/models/IProcedureCodes';
import { ProcedureCodesService } from 'src/app/Services/ProcedureCodes/procedure-codes.service';
import { CalendarTemplateDay } from 'src/app/models/CalendarTemplate';
import { AESAlgorithm } from 'src/app/Utilities/Crypto/AESAlgorithm';
import { appiontMentResultDTO } from 'src/app/models/AppiontMentResultDTO';
import { ConfirmationDialogComponent } from 'src/app/ChildControls/confirmation-dialog/confirmation-dialog.component';
import { RemarksComponent } from 'src/app/ChildControls/remarks/remarks.component';
import { DateDialogComponent } from 'src/app/ChildControls/date-dialog/date-dialog.component';
import { IAvailableSlots } from 'src/app/models/IAvailableSlots';
import { PatientappointmentsdialogComponent } from 'src/app/ChildControls/patientappointmentsdialog/patientappointmentsdialog.component';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { CustomSlotComponent } from 'src/app/ChildControls/custom-slot/custom-slot.component';
import { ExportToCsv } from 'export-to-csv';
//import * as XLSX from 'xlsx';
import XLSX from 'xlsx'
import { ProceduresDialogComponent } from 'src/app/ChildControls/procedures-dialog/procedures-dialog.component';
import { PersonalInfoService } from 'src/app/Services/Demographics/personal-info.service';
import { IPersonalInfo } from 'src/app/models/IPersonalInfo';
import { configuration } from 'src/environments/environment';
import moment from 'moment';
import { async } from 'rxjs/internal/scheduler/async';


interface Remark {
  value: string;
  viewValue: string;
}
export class SendMessageRequest {
  FromPhoneNumber: string;
  Messagge: string;
  ToPhoneNumber: string;
}
class BlockedAppointment {
  color: string = 'rgb(220,220,220)'; //grey
  visitTypeText: string = '';
  duration: string = '';
  visitTypeId: string = '';
  allowResize: boolean = false;
  patName: string = '';
  dob: string = '';
  providerName: string = '';
  appDate: string = '';
  phone: string = '';
  Id: string = '';
  physician: string = '';
}

class Availlist {
  currDate: Date = null;
  shortDate: string = '';
  noofSlots: number = null;
}


declare let $: any;
declare let FullCalendar: any;
declare let FullCalendarInteraction: any;
declare let window: any;
// export class warningDialogModel {
//   constructor(public temptile: string, public message: string) {
//   }
// }
@Component({
  selector: 'app-new-appointment',
  templateUrl: './new-appointment.component.html',
  styleUrls: ['./new-appointment.component.css']
})


export class NewAppointmentComponent implements OnInit {
  @ViewChild('patsearchslider', { static: true }) public sidenav: MatSidenav;
  @Output() patientBanner: EventEmitter<any> = new EventEmitter<any>();
  public eventsData: any = [];
  visitTypes: any = [];
  dayscount = 3;
  name = 'Angular';
  calenderView: any;
  blockedAppointments: BlockedAppointment[] = [];
  public exportTime = { hour: 7, minute: 15, meriden: 'PM', format: 24 };
  selectedDate: any;
  currentAppDate: Date;
  calendarHeaderDate: string = '';
  scheduleAppointment: boolean = false;
  public isTemplateActive: boolean = true;
  public fromProviderCal: boolean = false;
  public fromfollowup: boolean = false;
  public disableTime: boolean = true;
  ReadOnlyCheck: boolean;
  noShowMessage: string = '';
  IsSlotfromTemplete: boolean = true;
  onChangeHour(event) {
  }
  public show: boolean = false;
  public worklistdrp: boolean = false;
  showInfo() {
    this.show = !this.show;
  }
  availableSlot: IAvailableSlots[] = [];
  appointmentInfo: IAppointmentData;
  NewAppointmentForm: FormGroup;
  submitted = false;
  public result: any;
  public results: boolean;
  public fetchedprocedure: string = "";
  public lstVistTypes: IVisitTypes[];
  public lstProviders: IUserDetails[];
  public lstProvider: IUserDetails[];
  public supervisingProviders: IUserDetails[];
  public billingProviders: IUserDetails[];
  public lstRooms: IRoomsInfo[];
  public lstLocations: ILocationDetails[];
  public lstLocation: ILocationDetails[];
  public procedireRecord: IProcedureCodes[] = [];
  public PopUpAlerts: IAlerts[] = [];
  public activeProcedures: IprocedureCode[] = [];
  //noPatient:boolean=false;
  public selectedAppId: string = '';
  public selectedLocationId: number = 0;
  public selectedDuration: number = 0;
  public selectedProviderId: string = '';
  public selectedvisitTypeId: number = 0;
  public inputDate: any;
  public inputEndDate: any;
  public rescheduleRemarks: string = '';
  public rescheduleType: string = '';
  public Selectedcode: string = "";
  public apptitle: string = 'New Appointment';
  public btnText: string = 'Create Appointment';
  public starttimechk: string = "";
  public endtimechk: string = "";
  public screenName: string = "";
  public fromPatientPortal: string = '';
  public PatientPortalId: string = '';
  public selectedPPLocationId: number = 0;
  public IsFollowUpScreen: boolean = false;
  locID: number;
  minDate = new Date();
  visitdisable: boolean = true;
  public todaydatee: string;
  public isEnabledTelemedicine: boolean;
  rolealert: string = "";
  role: string = "";
  constructor(private formBuilder: FormBuilder
    , private schedulerservice: SchedularServiceService
    //, public app: AppComponent
    , public datepipe: DatePipe
    , private toastr: ToastrService
    , private sharedService: SharedService
    , public dialog: MatDialog
    , private router: Router
    , private procService: ProcedureCodesService
    , private datePipe: DatePipe, private route: ActivatedRoute, private crypto: AESAlgorithm
    , private bannerService: PatientBannerService
    , private personalService: PersonalInfoService
    , public dateAdapter: DateAdapter<Date>) {
    this.dateAdapter.setLocale('en-US');
    this.datepipe = new DatePipe("en-US");
    //app.isLoggedIn$ = true;
    this.calenderView = 'timeGridDay';
    if (sessionStorage.getItem("LocationId") !== null && sessionStorage.getItem("LocationId") !== undefined) {
      this.locID = Number(sessionStorage.getItem("LocationId"));
    } else {
      this.locID = 0;
    }
    if (sessionStorage.getItem("patientId") !== null && sessionStorage.getItem("patientId") !== undefined) {
      CommonComponents.patientId = Number(sessionStorage.getItem("patientId"));
    }
    if (sessionStorage.getItem("patientName") !== null && sessionStorage.getItem("patientName") !== undefined) {
      CommonComponents.patientName = sessionStorage.getItem("patientName");
    }
    if (sessionStorage.getItem("screen") !== null && sessionStorage.getItem("screen") !== undefined) {
      this.screenName = sessionStorage.getItem("screen");
    }

    this.getProviderRole();
    if (CommonComponents.patientId != undefined && CommonComponents.patientId != 0) {
      this.getPeresonalInfo(CommonComponents.patientId);
    }

    this.getBlockedAppointments();
    this.role = sessionStorage.getItem("role");
  }
  isalert: string;



  ngOnInit() {
    this.isEnabledTelemedicine = configuration.IsEnableTelemedicine;
    $('#procedurefocus').on('focus', function () {
      $('#procedurefocushide').show();
    });
    $('#providersfocus').on('focus', function () {
      $('#providersfocushide').show();
    });
    $(document).click(function (event) {
      if (event.target.id != "procedurefocus") {
        var container = $("#procedurefocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
        if (event.target.id == "providersfocus") {
          $("#providersfocushide").show();
        }

      }
      if (event.target.id != "providersfocus") {
        var container = $("#providersfocushide");
        if (!container.is(event.target) && !container.has(event.target).length) {
          container.hide();
        }
        if (event.target.id == "procedurefocus") {
          $("#procedurefocushide").show();
        }
      }
    });
    var geturl = this.router.url;
    if (geturl.includes('1')) {

      this.isalert = geturl.split('/')[2];
    }
    this.dateAdapter.setLocale('en-US');
    this.datepipe = new DatePipe("en-US");
    this.selectedDate = moment(new Date()).toDate();
    this.NewAppointmentForm = this.formBuilder.group({
      PatientName: ['', Validators.required],
      ServiceSite: ['', Validators.required],
      RenderingProvider: ['', Validators.required],

      VisitType: ['', Validators.required],
      Room: [''],
      AppointmentDate: ['', Validators.required],
      StartTime: ['', Validators.required],
      EndTime: [''],
      Duration: ['', Validators.required],
      BillingProvider: [''],
      SuperVising: [''],
      Account: [''],
      AuthorizationCode: [''],
      FinanceCenter: [''],
      Comments: [''],
      worklistprovider: [''],
      worklistlocation: [''],
      notesComments: [''],
      customchk: ['']
    });

    // this.NewAppointmentForm.markAllAsTouched();
    // this.NewAppointmentForm.valueChanges.subscribe((data) => {
    //   this.logValidationErrors(this.NewAppointmentForm);

    // });


    this.appointmentInfo = {
      Id: '',
      owningResourceId: '',
      startTimeZoneId: '',
      endTimeZoneId: '',
      subject: '',
      description: '',
      patientId: null,
      physician: '',
      visitId: null,
      duration: '',
      owningCalendarId: '',
      alertMessage: '',
      location: '',
      locationId: null,
      note: '',
      reasonForReferal: '',
      unMappedProperties: '',
      status: '',
      VariantProperties: null,
      reCurrenceVersion: null,
      isOccurrenceDeleted: false,
      reminderEnabled: false,
      maxOccurrenceDateTime: null,
      start: null,
      end: null,
      originalOccurrenceStart: null,
      originalOccurrenceEnd: null,
      reminderInterval: '',
      createdby: '',
      isLocked: false,
      isTimeZoneNeutral: false,
      isVisible: false,
      reminder: '',
      rootActivityId: '',
      recurrence: '',
      dbOperation: '',
      name: '',
      visitType: '',
      endTime: '',
      startTime: '',
      Date: '',
      usaDateFormate: '',
      roomName: '',
      roomId: '',
      reasonforReschedule: '',
      gender: '',
      action: '',
      patientPic: '',
      patientName: '',
      nurseName: '',
      encounterid: '',
      patEncStatus: '',
      dob: '',
      firstName: '',
      lastName: '',
      encStatus: null,
      visible: false,
      phyName: '',
      nurse: '',
      signOffStatus: '',
      appointmentTime: '',
      signOffNurse: '',
      checkOutPerson: '',
      statusColor: '',
      modifiedBy: '',
      modifiedOn: null,
      //For Merge data
      appointmentCount: null,
      mergePatientId: null,
      txtColVisiblity: false,
      //Encounterselected type
      fromPatientboard: false,
      patientActive: false,
      problemCode: '',
      problemDesc: '',
      patSSN: '',
      medicationAllergies: '',
      patDOB: null,
      resultStatus: '',
      resultValue: '',
      resultVisibility: '',
      labTestName: '',
      referralStatus: '',
      eType: '',
      reScheduleFlag: false,
      reScheduleAppId: '',
      insurance: '',
      checkedInDateTime: null,
      checkedOutDateTime: null,
      vitals: '',
      checkedInTime: '',
      checkedOutTime: '',
      checkedInOutTime: '',
      ProcedureName: '',
      appReminders: null,
      checkAuthorizeData: false,
      statusTooltipVisiblity: false,
      commentsTooltipVisiblity: false,
      insuranceStatus: '',
      supervisorProvider: '',
      clinicTimeDurtion: null,
      receivedAmount: '',
      depositDate: '',
      cashAmount: '',
      chequeAmount: '',
      cardAmount: '',
      claimStatus: '',
      charges: '',
      procedureCodes: '',
      claimId: '',
      homePhone: '',
      cellPhone: '',
      workPhone: '',
      coPay: '',
      referralid: null,
      referralName: '',
      npiId: null,
      npiName: '',
      createdOn: null,
      comments: '',
      facilityId: null,
      visitNote: null,
      orNote: null,
      orderNote: null,
      visitNoteStatus: '',
      orNoteStatus: '',
      visitCategory: '',
      pumpStatus: '',
      billingProvider: '',
      authId: null,
      procedureName: '',
      userId: '',
      role: '',
      reason: '',
      date: '',
      ctdayId: 0,
      orderEncounterId: ''
      , physicianLastFrstName: ''
      , notesDetails: '',
      appStatus: '',
      screen: '',
      PPRequestId: null,
      appType: null,
      isProvider: false,
      isNurse: false,
      patientLink: '',
      providerLink: '',
      patEmail: '',
      patEncryptlink: '',
      provEncryptLink: "",
      gidId: '',
      appointDate: '',
      isTele: false,
      patCellNo: '',
      appStartTime: '',
      patTeleSMS: '',
      isCallComplete: null,
      isCallWait: false,
      commentsOnly: '',
      locTwillioPhoneNum: '',
      authorizationComments:'',
      eligibilityComments: '',
      eligibilityWorkStatusId:0,
      eligibilityWorkStatusName:'',
       authStatusId:0,
       workStatusName :'',
      professionalClaimStatus: '',
      institutionalClaimStatus: '',
      dpatId:null
    };
    if (CommonComponents.patientId == 0) {
      // sessionStorage.removeItem("patientName");
      CommonComponents.patientName = "";
    }
    if (CommonComponents.patientName != '' && CommonComponents.patientName != undefined) {
      // this.createddate();
      this.NewAppointmentForm.patchValue({
        PatientName: CommonComponents.patientName,
        // AppointmentDate: new Date()
      });
      this.currentAppDate = moment(new Date()).toDate();
    } else {
      // this.createddate();
      // this.NewAppointmentForm.patchValue({
      //   // AppointmentDate: new Date()
      // });
      const message = 'Select Patient ID ';
      const dialogData = new warningDialogModel('Alert !', message);
      const dialogRef = this.dialog.open(WarningDialogComponent, {
        width: '220px',
        height: '130px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(dialogResult => {
        this.results = dialogResult;
        if (this.results == true) {
          document.getElementById("openmethos").click();
          //this.app.fnCallParentFromNewAppointments();
          // this.app.sidenav.open();

        }
      });
    }


    if (CommonComponents.patientId > 0 && (this.isalert === undefined || this.isalert === null || this.isalert === "")) {
      this.todaydatee = '';
      this.todaydatee = this.datepipe.transform(moment(Date.now()).toDate(), 'MM/dd/yyyy');
      this.sharedService.getAlertsInfo(CommonComponents.patientId, this.todaydatee)
        .subscribe(async (data: any) => {
          ;
          await data;

          this.sharedService.lstPopUpAlerts = data;// this.lstalerts;
          if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
            // var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isDemographics == true && attr.isDismiss == true);
            // if (alertcount != null && alertcount.length > 0) {
            // this.PopUpAlerts = alertcount;
            this.PopUpAlerts = this.sharedService.lstPopUpAlerts.filter(d => d.isScheduling === true);
            this.PopUpAlerts = this.PopUpAlerts.filter((attr: IAlerts) => !attr.rolesName || attr.rolesName.includes(sessionStorage.getItem("role")));
            this.sharedService.lstPopUpAlerts = null;
            if (this.PopUpAlerts.length > 0) {
              this.rolealert = "";
              this.PopUpAlerts.forEach(element => {
                if (element.rolesName != null && element.rolesName != "") {
                  this.rolealert += element.rolesName + ',';
                }
              });
              if (this.rolealert != null && this.rolealert != undefined && this.rolealert != "") {
                if (this.rolealert.includes(sessionStorage.getItem("role"))) {
                  this.openAlertsPopup();
                }
              } else {
                this.openAlertsPopup();
              }
            }
            // }
          }
        },
          (err: any) => console.log(err)
        );
      // if (this.sharedService.lstPopUpAlerts != null && this.sharedService.lstPopUpAlerts.length > 0) {
      //   var alertcount = this.sharedService.lstPopUpAlerts.filter((attr: IAlerts) => attr.isScheduling == true && attr.isDismiss == true);
      //   if (alertcount != null && alertcount.length > 0) {
      //     this.PopUpAlerts = alertcount;
      //     this.openAlertsPopup();
      //   }
      //   else {
      //     this.PopUpAlerts = null;
      //   }
      // }
    }
    var currentdate = new Date(2012, 11);
    var datetime = "Last Sync: " + currentdate.getDate() + "/"
      + (currentdate.getMonth() + 1) + "/"
      + currentdate.getFullYear() + " @ "
      + currentdate.getHours() + ":"
      + currentdate.getMinutes() + ":"
      + currentdate.getSeconds();
    // alert(datetime);
    var currenttime = 17;// datetime.split('@')[1];
    var currenttime1 = 18;
    var currenttime2 = 19;
    var currenttime3 = 20;
    //if (Number(currenttime.split(':')[0]) >= 15) {

    if (currenttime === 17) {
      var date = moment(new Date()).toDate();
      var d = date.getDate();

      var m = date.getMonth();
      var y = date.getFullYear();
    }
    $(function () {
      window.myFunc = function myFunc(event) {
      }
    });

    this.fromProviderCal = false;
    this.route.queryParams.subscribe(params => {
      var physiciann = this.crypto.urlParmeterDecoder(decodeURIComponent(params['providerId']));
      if (physiciann != null && physiciann != undefined)
        this.appPhysician = physiciann;
      this.selectedAppId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['id']));
      if (this.selectedAppId == 'undefined')
        this.selectedAppId = undefined;
      var fromprovValue = this.crypto.urlParmeterDecoder(decodeURIComponent(params['fromProviderCal']));
      this.fromPatientPortal = this.crypto.urlParmeterDecoder(decodeURIComponent(params['RequestFrom']));
      this.PatientPortalId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['PPReqId']));
      if (fromprovValue == "true") {
        this.fromProviderCal = true;
      } else {
        this.fromProviderCal = false;
      }
      var fromfollowupvalue = this.crypto.urlParmeterDecoder(decodeURIComponent(params['fromFollowup']));
      if (fromfollowupvalue == "true") {
        this.fromfollowup = true;
        this.IsFollowUpScreen = true;
      } else {
        this.fromfollowup = false;
        this.IsFollowUpScreen = false;
      }
      var nextappointment = this.crypto.urlParmeterDecoder(decodeURIComponent(params['nextappointment']));
      if (nextappointment === "true") {
        sessionStorage.setItem("nextapp", nextappointment);
      }
      else {
        sessionStorage.removeItem("nextapp");
      }
    });
    // if (!this.fromProviderCal)
    //   this.createddate();
    if (!this.fromProviderCal && this.fromPatientPortal != 'Portal')
      this.createddate();
    if (this.fromPatientPortal == 'Portal') {
      this.route.queryParams.subscribe(params => {
        this.selectedPPLocationId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['PPLocId']));

        this.selectedProviderId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['providerId']));
        this.inputDate = this.crypto.urlParmeterDecoder(decodeURIComponent(params['appDate']));
        if (this.inputDate != null && this.inputDate != undefined && this.inputDate != 'undefined') {
          sessionStorage.setItem('appDate', this.inputDate);
          this.NewAppointmentForm.patchValue({
            ServiceSite: this.selectedPPLocationId,
            RenderingProvider: this.selectedProviderId,
            AppointmentDate: moment(this.inputDate).toDate(),
          });

        } else {
          this.NewAppointmentForm.patchValue({
            ServiceSite: this.selectedPPLocationId,
            RenderingProvider: this.selectedProviderId,
          });
          this.createddate();
        }
      });
      this.initilizeCalender();
      this.getCalenderByDate(this.NewAppointmentForm.value.AppointmentDate);
      this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");
    }
    if (this.selectedAppId != null && this.selectedAppId != undefined && this.selectedAppId != 'undefined') {
      // this.getAppointmentbyId(null);
      this.route.queryParams.subscribe(params => {
        this.inputDate = this.crypto.urlParmeterDecoder(decodeURIComponent(params['appDate']));

        if (this.fromProviderCal)
          sessionStorage.setItem('appDate', this.inputDate);
      });
    } else {
      this.route.queryParams.subscribe(params => {
        var templocId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['locationId']));
        if (templocId !== "undefined" && templocId !== null && templocId !== 0 && templocId !== undefined)
          this.selectedLocationId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['locationId']));
        else
          this.selectedLocationId = 0;
        this.selectedProviderId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['providerId']));
        this.selectedvisitTypeId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['visitId']));
        this.inputDate = this.crypto.urlParmeterDecoder(decodeURIComponent(params['appDate']));

        if (this.fromProviderCal)
          sessionStorage.setItem('appDate', this.inputDate);
        this.inputEndDate = this.crypto.urlParmeterDecoder(decodeURIComponent(params['appendDate']));
        this.selectedctdayId = this.crypto.urlParmeterDecoder(decodeURIComponent(params['ctddayId']));
        this.selectedDuration = this.crypto.urlParmeterDecoder(decodeURIComponent(params['duration']));
        this.selectedStartDate = this.inputDate;
        this.selectedEndDate = this.inputEndDate;
      });

      if (this.selectedLocationId != 0 && this.selectedvisitTypeId != 0 && this.selectedProviderId != null && this.selectedProviderId != undefined && this.selectedProviderId != 'undefined') {
        if (this.inputDate != null && this.inputDate != undefined && this.inputDate != 'undefined') {
          var startTime = this.transformTimeFormat(moment(this.inputDate).toDate().getHours(), moment(this.inputDate).toDate().getMinutes());
          var splitColumns = startTime.split(':');
          var hour = splitColumns[0];
          var mins = splitColumns[1];
          if (hour == "00") {
            hour = "12";
            startTime = hour + ":" + mins;
          }
        }
        else
          this.inputDate = moment(new Date()).toDate();
        if (this.selectedDuration != 0 && this.selectedDuration != undefined && this.selectedDuration.toString() != 'undefined')
          this.slotduration = this.selectedDuration.toString();
        else {
          this.slotduration = '';
          this.selectedDuration = null;
        }

        if (this.selectedctdayId != -1) {
          this.NewAppointmentForm.patchValue({

            ServiceSite: this.selectedLocationId,
            RenderingProvider: this.selectedProviderId,
            VisitType: this.selectedvisitTypeId.toString(),
            AppointmentDate: moment(this.inputDate).toDate(),
            StartTime: startTime,
            Duration: this.selectedDuration
          });
        } else {
          this.NewAppointmentForm.patchValue({
            ServiceSite: this.selectedLocationId,
            RenderingProvider: this.selectedProviderId,

            AppointmentDate: moment(this.inputDate).toDate(),
          });
        }
        this.initilizeCalender();
        // this.getCalenderByDate(moment(this.NewAppointmentForm.value.AppointmentDate).toDate());
        // this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");

      }     

    }

    this.getCalenderByDate(moment(this.NewAppointmentForm.value.AppointmentDate).toDate());
    this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");
   
    this.route.queryParams.subscribe(params => {
      this.rescheduleType = this.crypto.urlParmeterDecoder(decodeURIComponent(params['type']));
      this.rescheduleRemarks = this.crypto.urlParmeterDecoder(decodeURIComponent(params['remarks']));
    });
    // setTimeout(() => {
    //   this.app.HyperLinkClicks('New Appointment');
    // }, 700);

    this.NewAppointmentForm.markAllAsTouched();
    this.NewAppointmentForm.valueChanges.subscribe((data) => {
      this.logValidationErrors(this.NewAppointmentForm);

    });
  }
  onSelectionChanged(event, type: string) {
    //this.fnAssistant = true;
    setTimeout(() => {
      if (event !== null && event !== undefined) {
        $(event.target).prev().trigger('focus');
      }
    }, 100);
  }
  ngAfterContentInit() {
    this.onload();
  }
  createddate() {
    this.schedulerservice.getservercurrentdate().subscribe(async result => {
      await result;
      this.NewAppointmentForm.patchValue({
        AppointmentDate: moment(result).toDate()
      });
    });
  }

  openAlertsPopup(): void {
    const dialogRef = this.dialog.open(PopupAlertsComponent, {
      width: '1000px',
      height: '500px',
      data: this.PopUpAlerts
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined)

        { }

    });
  }

  CustVisitType: string; CustProvider: string; CustDate: string; endtimeSlot: string; starttimeSlot: string;
  slotinsertstarttime: string; slotstarttime: string; CLocation: number;
  slotinsertendtime: string;
  openCustomSlot(event) {

    if (event.checked == true) {
      if (this.NewAppointmentForm.value.PatientName == '') {
        this.toastr.warning("Please select Patient Name");
        this.NewAppointmentForm.patchValue({
          customchk: false,
        });
        return false;
      }
      if (this.NewAppointmentForm.value.ServiceSite == '') {
        this.toastr.warning("Please select Location");
        this.NewAppointmentForm.patchValue({
          customchk: false,
        });
        return false;

        // sds
      }
      if (this.NewAppointmentForm.value.RenderingProvider == '') {
        this.toastr.warning("Please select Provider");
        this.NewAppointmentForm.patchValue({
          customchk: false,
        });
        return false;
      }

      // if (this.NewAppointmentForm.value.Room == '') {
      //   this.toastr.warning("Please select Room");
      //   this.NewAppointmentForm.patchValue({
      //     customchk: false,
      //   });
      //   return false;
      // }
      if (this.NewAppointmentForm.value.AppointmentDate == '') {
        this.toastr.warning("Please select Appointment Date");
        this.NewAppointmentForm.patchValue({
          customchk: false,
        });
        return false;
      }

      if (this.NewAppointmentForm.value.VisitType == '') {
        this.toastr.warning("Please select Visit Type");
        this.NewAppointmentForm.patchValue({
          customchk: false,
        });
        return false;
      }
      this.CustVisitType = this.NewAppointmentForm.value.VisitType;
      this.CustProvider = this.NewAppointmentForm.value.RenderingProvider;
      this.CustDate = this.NewAppointmentForm.value.AppointmentDate;
      this.CLocation = this.NewAppointmentForm.value.ServiceSite;
      // var lsttimeslots = this.createTimeSlots(new Date(this.currentLocation.startTime).getHours(), new Date(this.currentLocation.endTime).getHours(), this.currentLocation.slotTimeDuration);
      var lsttimeslots = this.createTimeSlots(new Date(this.currentLocation.startTime), new Date(this.currentLocation.endTime), this.currentLocation.slotTimeDuration);

      const dialogRef = this.dialog.open(CustomSlotComponent, {
        width: '670px',
        height: '230px',
        data: { CVisit: this.CustVisitType, CProvider: this.CustProvider, CDate: this.CustDate, CLocId: this.CLocation, lstTimeslots: lsttimeslots }
      });


      dialogRef.afterClosed().subscribe(result => {

        if (result == undefined) {
          this.NewAppointmentForm.patchValue({
            customchk: false,
          });
          return false;
        } else {
          this.slotstarttime = result;
          var starttime = result;
          var splitColumns = result.split(':');
          var hour = splitColumns[0];
          var mins = splitColumns[1];
          var spiltmins = mins;
          var splitSpace = spiltmins.split(' ');
          var minutes = splitSpace[0];
          var AmPm = splitSpace[1].toUpperCase().trim();
          var addMinutes = Number(minutes) + Number(this.slotduration);
          if (splitColumns[0] == "12" && AmPm == "AM")
            hour = "00";

          //minutes conversion
          if (addMinutes > 59) {
            hour = Number(hour) + 1;
            minutes = Number(addMinutes - 60);

            if (minutes > 59) {
              hour = Number(hour) + 1;
              minutes = Number(minutes - 60);
            }
          }
          else {
            minutes = addMinutes;
          }




          if (minutes.toString().length == 1) {
            var doubleminutes = "0" + minutes.toString();
            minutes = doubleminutes;
          }

          //for am time calculation 
          if (AmPm == "AM") {
            if (splitColumns[0] == "12")
              this.starttimeSlot = ("00" + ':' + splitSpace[0] + ' ' + AmPm).toString();
            else
              this.starttimeSlot = (splitColumns[0] + ':' + splitSpace[0] + ' ' + AmPm).toString();

            if (splitColumns[0] != "12" && hour == 12)
              AmPm = "PM";

            if (hour.toString().length == 1) {
              var doublehours = "0" + hour.toString();
              hour = doublehours;
              if (hour == "00") {
                hour = "12";
              }
            }

            this.endtimeSlot = (hour + ':' + minutes + ' ' + AmPm).toString();

          }
          else {
            // for pm calculation   
            if (Number(splitColumns[0]) == 12)
              this.starttimeSlot = (Number(splitColumns[0]) + ':' + splitSpace[0] + ' ' + AmPm).toString();
            else {
              this.starttimeSlot = (Number(splitColumns[0]) + 12 + ':' + splitSpace[0] + ' ' + AmPm).toString();
              hour = Number(hour) + 12;
            }

            if (Number(hour) > 12)
              starttime = (12 - hour) + ":" + minutes;

            // if(Number(hour)==24 && minutes=="00")
            //      hour ="24";


            this.endtimeSlot = (hour + ':' + minutes + ' ' + AmPm).toString();

          }
          //    this.toastr.success ("star n end slot "+this.starttimeSlot +' '+this.endtimeSlot);        
          var STime = this.starttimeSlot.split(' ');
          var ETime = this.endtimeSlot.split(' ');
          this.slotinsertstarttime = STime[0];
          this.slotinsertendtime = ETime[0];
          this.NewAppointmentForm.patchValue({
            StartTime: this.slotstarttime,
            Duration: this.slotduration,
          });
          this.selectedctdayId = -1;
          this.schedulerservice.getCalendarslot(this.NewAppointmentForm.value.ServiceSite, this.slotinsertstarttime, this.slotinsertendtime).subscribe((events: boolean) => {
            if (events == true) {
              // this.toastr.success("successfully slot added");
              this.selectedctdayId = -1; var selectedslotEndDate = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
              this.selectedEndDate = selectedslotEndDate + "T" + this.slotinsertendtime + ":00";
            } else {
              this.toastr.warning("out of location timings");
              this.selectedctdayId = 0;
              this.NewAppointmentForm.patchValue({
                StartTime: "",
                // Duration: "",
                customchk: false,
              });
            }
          });
        }
      });
    }
    else {
      const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
        width: '400px',
        height: '150px',
        data: { headerText: 'This will remove the current selected slot. Do you want to proceed ?' }
      });

      dialogRef2.afterClosed().subscribe(dialogResult => {
        if (dialogResult == true) {
          this.selectedctdayId = 0;
          this.NewAppointmentForm.patchValue({
            // Duration: '',
            StartTime: null,
          });
        }
        else {
          this.NewAppointmentForm.patchValue({
            customchk: true,
          });
          if (this.selectedAppId && this.selectedAppId != '')
            this.getAppointmentbyId(null);
        }
      });

    }

  }

  tester() {

  }
  DisableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.DisableAllFormControls(abstractControl);
      } else {
        abstractControl.disable();
      }
    });
  }

  formErrors = {
    'ServiceSite': '',
    'RenderingProvider': '',

    'VisitType': '',
    'AppointmentDate': '',
    'Duration': ''

  };

  validationMessages = {
    'ServiceSite': {
      'required': 'Service Site is required.'
    },
    'RenderingProvider': {
      'required': 'Rendering Provider is required.',

    },

    'VisitType': {
      'required': 'Visit Type  is required.',
    },
    'AppointmentDate': {
      'required': 'Appointment Date is required.',
    },
    'Duration': {
      'required': 'Duration is required.',
    }

  };
  EnableAllFormControls(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.EnableAllFormControls(abstractControl);
      } else {
        abstractControl.enable();
      }
    });
  }
  logValidationErrors(group: FormGroup = this.NewAppointmentForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid
          && (abstractControl.touched || abstractControl.dirty)) {
          const messages = this.validationMessages[key];
          for (const errorKey in abstractControl.errors) {
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }

  Cancel() {
    if (this.NewAppointmentForm.value != null) {
      this.NewAppointmentForm.reset({
        'ServiceSite': '',
        'RenderingProvider': '',

        'VisitType': '',
        'AppointmentDate': '',
        'Duration': ''
      });
    }
    // alert(this.fromProviderCal)


    if (this.fromProviderCal)
      this.router.navigateByUrl('/ProviderCalender');
    else if (this.fromfollowup) {
      sessionStorage.setItem("followNextApp", "true");
      this.router.navigateByUrl('/Follow-Up');
    }
    else if (this.screenName == "ReferralTracker") {
      this.router.navigateByUrl('/patientreferraltracker');
      sessionStorage.removeItem("screen");
    }
    else if (this.fromPatientPortal == 'Portal') {
      // this.router.navigate(['messageInbox']);
      this.router.navigate(['tasksandmessages/', 'BackToMessages']);
    }
    else {
      //siva
      if (sessionStorage.getItem("PatientBoardDefaultDate")) {
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("encounterid");
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.router.navigateByUrl('/Appointments');
      }
      else if (sessionStorage.getItem("nextapp")) {
        sessionStorage.removeItem("patientId");
        sessionStorage.removeItem("patientName");
        sessionStorage.removeItem("encounterid");
        CommonComponents.patientId = 0;
        CommonComponents.patientName = '';
        this.bannerService.toggle(Number("-1"));
        this.router.navigateByUrl('/Appointments');
      }
      else {
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment']));
        this.onRefreshClick();
      }
      //
    }

  }
  // convenience getter for easy access to form fields
  get f() { return this.NewAppointmentForm.controls; }

  async onload() {
    // this.sharedService.getAllUsersByRole(Defaults.doctorType).subscribe(data => {
    //   this.lstProviders = data;
    //   this.supervisingProviders = data;
    // });
    this.sharedService.getAllUsersByRole(Defaults.doctorType).subscribe(data => {
      this.lstProvider = data;
    });
    // this.sharedService.getAllUsersByRoleWithOutLocId(Defaults.doctorType).subscribe(data => {
    //   this.lstProviders = data;
    //   this.supervisingProviders = data;
    // });
    // this.sharedService.getAllUsersByRoleWithOutLocId(Defaults.doctorType).subscribe(data => {
    //   this.lstProvider = data;
    // });

    this.schedulerservice.getVisitTypes().subscribe(data => {
      this.lstVistTypes = data;
    });
    // await this.schedulerservice.getLocations().subscribe(data => {
    //   this.lstLocations = data;
    //   this.lstLocations = this.lstLocations.filter(a => a.active == true);
    // });
    await this.schedulerservice.getLocations().subscribe(data => {
      this.lstLocations = data;
      this.lstLocations = this.lstLocations.filter(a => a.active == true);
      // this.lstLocation = data;
      // this.lstLocation = this.lstLocation.filter(a => a.active == true)
      if (this.locID !== 0 && this.apptitle == 'New Appointment' && this.selectedPPLocationId == 0 && (this.selectedLocationId == 0 || this.selectedLocationId == undefined)) {
        this.NewAppointmentForm.patchValue({
          ServiceSite: this.locID,
        });
        // this.getlocationbasedproviders();
      } else if (this.selectedLocationId !== 0 && this.selectedPPLocationId == 0) {
        this.NewAppointmentForm.patchValue({
          ServiceSite: this.selectedLocationId,
        });
        // this.getlocationbasedproviders();
      }
      else if (this.selectedLocationId == 0 && this.selectedPPLocationId !== 0) {
        this.NewAppointmentForm.patchValue({
          ServiceSite: this.selectedPPLocationId,
        });
        // this.getlocationbasedproviders();
      }
      setTimeout(() => {
        this.getlocationbasedproviders();
      }, 1000);

      //this.getActiveProcedures();
    });

    this.getRoomsbyLocation();
    //  this.getBillingProviders();
    this.getActiveProcedures();
  }

  public covertStarttime: string;
  public covertEndtime: string;
  public appResult: appiontMentResultDTO;
  onSubmit(isAppCreate: boolean) {
    this.submitted = true;
    // stop here if form is invalid
    if (this.NewAppointmentForm.invalid) {
      return;
    }
    if (this.selectedctdayId == 0 || this.selectedctdayId == null || this.selectedctdayId == undefined) {
      this.toastr.warning("Please select slot");
      return;
    }
    else {
      this.mapFormValuesToAppointmentModel();
      this.teleobj = this.lstVistTypes.filter(x => x.visitId == this.NewAppointmentForm.value.VisitType);
      if (this.teleobj != null && this.teleobj != undefined) {
        if (this.teleobj[0].isTelemedicine == true && this.isEnabledTelemedicine == true) {
          //if (this.patEmailId != "" || this.patCellPhone != "") {
          let selectProvName = this.lstProviders.filter(x => x.userId === this.NewAppointmentForm.value.RenderingProvider)
          this.appointmentInfo.patEmail = this.patEmailId;
          this.appointmentInfo.patCellNo = this.patCellPhone;
          this.appointmentInfo.isTele = this.teleobj[0].isTelemedicine
          this.appointmentInfo.visitType = this.teleobj[0].visitType
          this.appointmentInfo.isCallComplete = 1;
          //}
        } else {
          this.appointmentInfo.patEmail = this.patEmailId;
          this.appointmentInfo.patCellNo = this.patCellPhone;
          this.appointmentInfo.isTele = false;
          this.appointmentInfo.visitType = this.teleobj[0].visitType
          this.appointmentInfo.patEncryptlink = '';
          this.appointmentInfo.provEncryptLink = '';
          this.appointmentInfo.isCallComplete = 0;
        }
      } else {
        this.appointmentInfo.patEmail = this.patEmailId;
        this.appointmentInfo.patCellNo = this.patCellPhone;
        this.appointmentInfo.isTele = false;
        this.appointmentInfo.visitType = this.teleobj[0].visitType
        this.appointmentInfo.patEncryptlink = '';
        this.appointmentInfo.provEncryptLink = '';
        this.appointmentInfo.isCallComplete = 0;
      }
    }
    if (this.NewAppointmentForm.value.Duration == '' || this.NewAppointmentForm.value.Duration == undefined) {
      const message = 'Select Appointment Start time and End Time';
      const dialogData = new warningDialogModel('Alert !', message);
      const dialogRef = this.dialog.open(WarningDialogComponent, {
        maxWidth: '400px',
        height: '120px',
        data: dialogData
      });
      dialogRef.afterClosed().subscribe(dialogResult => {
      });

    } else {
      if (this.isTemplateActive == true) {
        if (this.selectedAppointment == null || this.selectedAppointment == undefined) {
          //  this.appointmentInfo.ctdayId = this.selectedctdayId;
          var locationsName = this.lstLocations.find(loc => loc.locationId == this.NewAppointmentForm.value.ServiceSite);
          //TODO
          var selectedloc = Number(this.NewAppointmentForm.value.ServiceSite);
          if (this.locID !== selectedloc) {
            const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
              width: '400px',
              height: '200px',
              data: { headerText: 'You are creating an appointment to a different location (' + locationsName.locationName + '). Do you wish to proceed?' }
            });

            dialogRef2.afterClosed().subscribe(dialogResult => {
              if (dialogResult == true) {
                this.schedulerservice.insertAppointment(this.appointmentInfo, isAppCreate).subscribe(
                  results => {
                    this.getActiveProcedures1();
                    this.appResult = results;
                    if (this.appResult.isCreated) {
                      if (this.appResult.result === 'Appointment already exists for this Patient with this provider') {
                        this.toastr.warning(this.appResult.result);
                        return;
                      }
                      this.toastr.success(this.appResult.result);
                      sessionStorage.setItem("appDate", this.NewAppointmentForm.value.AppointmentDate);
                      if (this.fromProviderCal) {
                        this.router.navigateByUrl('/ProviderCalender');
                      }
                      // else if (this.fromfollowup)
                      //   this.router.navigateByUrl('/Follow-Up');
                      else if (this.fromfollowup && this.IsFollowupCreateApp == false) {
                        sessionStorage.setItem("followNextApp", "true");
                        this.router.navigateByUrl('/Follow-Up');
                      }
                      else if (this.fromfollowup && this.IsFollowupCreateApp == true) {
                        this.IsFollowUpScreen = true;
                        this.clearFieldsAfterSubmit();
                        if (this.btnText == "Modify Appointment") {
                          this.apptitle = 'New Appointment';;
                          this.btnText = 'Create Appointment';
                        }
                      }
                      else if (this.screenName == "ReferralTracker") {
                        this.router.navigateByUrl('/patientreferraltracker');
                        sessionStorage.removeItem("screen");
                      }
                      else if (this.fromPatientPortal == 'Portal') {
                        //this.router.navigate(['messageInbox']);
                        this.router.navigate(['tasksandmessages/', 'BackToMessages']);
                      }
                      else {
                        //siva
                        if (sessionStorage.getItem("PatientBoardDefaultDate")) {
                          sessionStorage.removeItem("patientId");
                          sessionStorage.removeItem("patientName");
                          sessionStorage.removeItem("encounterid");
                          CommonComponents.patientId = 0;
                          CommonComponents.patientName = '';
                          this.bannerService.toggle(Number("-1"));
                          this.router.navigateByUrl('/Appointments');
                        }
                        else if (sessionStorage.getItem("nextapp")) {
                          sessionStorage.removeItem("patientId");
                          sessionStorage.removeItem("patientName");
                          sessionStorage.removeItem("encounterid");
                          CommonComponents.patientId = 0;
                          CommonComponents.patientName = '';
                          this.bannerService.toggle(Number("-1"));
                          this.router.navigateByUrl('/Appointments');
                        }
                        else {
                          this.clearFieldsAfterSubmit();
                          //  sessionStorage.setItem("LocationId", this.NewAppointmentForm.value.ServiceSite);
                          // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment', 1]));

                        }
                      }
                    } else {
                      this.onAppointmentCreateConformationDialog(this.appResult.result);
                    }
                  });
              }
              else {
                return;
              }
            });
          } else {
            this.schedulerservice.insertAppointment(this.appointmentInfo, isAppCreate).subscribe(
              results => {
                sessionStorage.removeItem("isPatientNoteHeight");
                this.getActiveProcedures1();
                this.appResult = results;
                if (this.appResult.isCreated) {
                  if (this.appResult.result === 'Appointment already exists for this Patient with this provider') {
                    this.toastr.warning(this.appResult.result);
                    return;
                  }
                  this.toastr.success(this.appResult.result);
                  sessionStorage.setItem("appDate", this.NewAppointmentForm.value.AppointmentDate);
                  if (this.fromProviderCal) {
                    this.router.navigateByUrl('/ProviderCalender');
                  }
                  // else if (this.fromfollowup)
                  //   this.router.navigateByUrl('/Follow-Up');
                  else if (this.fromfollowup && this.IsFollowupCreateApp == false) {
                    sessionStorage.setItem("followNextApp", "true");
                    this.router.navigateByUrl('/Follow-Up');
                  }
                  else if (this.fromfollowup && this.IsFollowupCreateApp == true) {
                    this.IsFollowUpScreen = true;
                    this.clearFieldsAfterSubmit();
                    if (this.btnText == "Modify Appointment") {
                      this.apptitle = 'New Appointment';;
                      this.btnText = 'Create Appointment';
                    }
                  }
                  else if (this.screenName == "ReferralTracker") {
                    this.router.navigateByUrl('/patientreferraltracker');
                    sessionStorage.removeItem("screen");
                  }
                  else if (this.fromPatientPortal == 'Portal') {
                    // this.router.navigate(['messageInbox']);
                    this.router.navigate(['tasksandmessages/', 'BackToMessages']);
                  }
                  else {
                    //siva
                    if (sessionStorage.getItem("PatientBoardDefaultDate")) {
                      sessionStorage.removeItem("patientId");
                      sessionStorage.removeItem("patientName");
                      sessionStorage.removeItem("encounterid");
                      CommonComponents.patientId = 0;
                      CommonComponents.patientName = '';
                      this.bannerService.toggle(Number("-1"));
                      this.router.navigateByUrl('/Appointments');
                    }
                    else if (sessionStorage.getItem("nextapp")) {
                      sessionStorage.removeItem("patientId");
                      sessionStorage.removeItem("patientName");
                      sessionStorage.removeItem("encounterid");
                      CommonComponents.patientId = 0;
                      CommonComponents.patientName = '';
                      this.bannerService.toggle(Number("-1"));
                      this.router.navigateByUrl('/Appointments');
                    }
                    else {
                      this.clearFieldsAfterSubmit();
                      //  sessionStorage.setItem("LocationId", this.NewAppointmentForm.value.ServiceSite);
                      // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment', 1]));
                      // this.router.navigateByUrl('/Appointments');
                    }
                  }
                } else {
                  this.onAppointmentCreateConformationDialog(this.appResult.result);
                }
              });
          }
        }
        else {
          if (this.starttimechk != null && this.starttimechk != undefined) {
            this.starttimechk = this.starttimechk.replace(" ", "");
            if (this.starttimechk.startsWith("0"))
              this.starttimechk = this.starttimechk.substring(1, 7);
          }
          var selectedstartdate = this.datepipe.transform(this.selectedAppointment.start, 'yyyy-MM-dd');
          var appointmentstartdate = this.datepipe.transform(this.appointmentInfo.start, 'yyyy-MM-dd');
          if (selectedstartdate.toString() != appointmentstartdate.toString() || this.selectedAppointment.visitId.toString() != this.appointmentInfo.visitId.toString() || this.selectedAppointment.physician != decodeURIComponent(this.appointmentInfo.physician) || this.selectedAppointment.locationId.toString() != this.appointmentInfo.locationId.toString()
            || this.selectedAppointment.ctdayId != this.appointmentInfo.ctdayId || this.selectedAppointment.startTime != this.starttimechk) {
            this.appointmentInfo.status = 'RESCHEDULE';
            if (sessionStorage.getItem("RescheduledNotesandReason")) {
              var appreason: any = JSON.parse(sessionStorage.getItem("RescheduledNotesandReason"));
              this.appointmentInfo.note = appreason.note;
              this.appointmentInfo.reason = appreason.reason;
              sessionStorage.removeItem("RescheduledNotesandReason");
            }

          }

          this.appointmentInfo.Id = this.selectedAppointment.Id;
          if (this.rescheduleType != null && this.rescheduleType != undefined && this.rescheduleType != '' && this.rescheduleType != 'undefined')
            this.appointmentInfo.reasonforReschedule = '';
          this.appointmentInfo.ctdayId = this.selectedctdayId;
          var locationsName = this.lstLocations.find(loc => loc.locationId == this.NewAppointmentForm.value.ServiceSite);
          //TODO
          var selectedloc1 = Number(this.NewAppointmentForm.value.ServiceSite);
          if (this.locID !== selectedloc1) {
            const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
              width: '400px',
              height: '200px',
              data: { headerText: 'You are creating an appointment to a different location (' + locationsName.locationName + '). Do you wish to proceed?' }
            });
            dialogRef2.afterClosed().subscribe(dialogResult => {
              if (dialogResult == true) {
                this.schedulerservice.updateAppointment(this.appointmentInfo).subscribe(
                  results => {
                    this.getActiveProcedures1();
                    this.result = results;
                    if (this.result === 'Appointment already exists for this Patient with this provider') {
                      this.toastr.warning(this.result);
                      return;
                    }
                    this.toastr.success(this.result);
                    sessionStorage.setItem("appDate", this.NewAppointmentForm.value.AppointmentDate);

                    if (this.fromProviderCal) {
                      this.router.navigateByUrl('/ProviderCalender');
                    }
                    // else if (this.fromfollowup)
                    //   this.router.navigateByUrl('/Follow-Up');
                    else if (this.fromfollowup && this.IsFollowupCreateApp == false) {
                      sessionStorage.setItem("followNextApp", "true");
                      this.router.navigateByUrl('/Follow-Up');
                    }
                    else if (this.fromfollowup && this.IsFollowupCreateApp == true) {
                      this.IsFollowUpScreen = true;
                      this.clearFieldsAfterSubmit();
                      if (this.btnText == "Modify Appointment") {
                        this.apptitle = 'New Appointment';;
                        this.btnText = 'Create Appointment';
                      }
                    }
                    else if (this.screenName == "ReferralTracker") {
                      this.router.navigateByUrl('/patientreferraltracker');
                      sessionStorage.removeItem("screen");
                    }
                    else if (this.fromPatientPortal == 'Portal') {
                      //this.router.navigate(['messageInbox']);
                      this.router.navigate(['tasksandmessages/', 'BackToMessages']);
                    }
                    else {
                      //siva
                      if (sessionStorage.getItem("PatientBoardDefaultDate")) {
                        sessionStorage.removeItem("patientId");
                        sessionStorage.removeItem("patientName");
                        sessionStorage.removeItem("encounterid");
                        CommonComponents.patientId = 0;
                        CommonComponents.patientName = '';
                        this.bannerService.toggle(Number("-1"));
                        this.router.navigateByUrl('/Appointments');
                      }
                      else if (sessionStorage.getItem("nextapp")) {
                        sessionStorage.removeItem("patientId");
                        sessionStorage.removeItem("patientName");
                        sessionStorage.removeItem("encounterid");
                        CommonComponents.patientId = 0;
                        CommonComponents.patientName = '';
                        this.bannerService.toggle(Number("-1"));
                        this.router.navigateByUrl('/Appointments');
                      }
                      else {
                        this.clearFieldsAfterSubmit();
                        //  sessionStorage.setItem("LocationId", this.NewAppointmentForm.value.ServiceSite);
                        // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment', 1]));

                      }

                    }
                  });
              }
              else {
                return;
              }
            });
          } else {
            this.schedulerservice.updateAppointment(this.appointmentInfo).subscribe(
              results => {
                this.getActiveProcedures1();
                this.result = results;
                if (this.result === 'Appointment already exists for this Patient with this provider') {
                  this.toastr.warning(this.result);
                  return;
                }
                this.toastr.success(this.result);
                sessionStorage.setItem("appDate", this.NewAppointmentForm.value.AppointmentDate);
                if (this.fromProviderCal) {
                  this.router.navigateByUrl('/ProviderCalender');
                }
                // else if (this.fromfollowup)
                //   this.router.navigateByUrl('/Follow-Up');
                else if (this.fromfollowup && this.IsFollowupCreateApp == false) {
                  sessionStorage.setItem("followNextApp", "true");
                  this.router.navigateByUrl('/Follow-Up');
                }
                else if (this.fromfollowup && this.IsFollowupCreateApp == true) {
                  this.IsFollowUpScreen = true;
                  //  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment']));
                  // this.onRefreshClick();
                  this.clearFieldsAfterSubmit();
                  if (this.btnText == "Modify Appointment") {
                    this.apptitle = 'New Appointment';;
                    this.btnText = 'Create Appointment';
                  }
                }
                else if (this.screenName == "ReferralTracker") {
                  this.router.navigateByUrl('/patientreferraltracker');
                  sessionStorage.removeItem("screen");
                }
                else if (this.fromPatientPortal == 'Portal') {
                  // this.router.navigate(['messageInbox']);
                  this.router.navigate(['tasksandmessages/', 'BackToMessages']);
                }
                else {
                  //siva
                  if (sessionStorage.getItem("PatientBoardDefaultDate")) {
                    sessionStorage.removeItem("patientId");
                    sessionStorage.removeItem("patientName");
                    sessionStorage.removeItem("encounterid");
                    CommonComponents.patientId = 0;
                    CommonComponents.patientName = '';
                    this.bannerService.toggle(Number("-1"));
                    this.router.navigateByUrl('/Appointments');
                  }
                  else if (sessionStorage.getItem("nextapp")) {
                    sessionStorage.removeItem("patientId");
                    sessionStorage.removeItem("patientName");
                    sessionStorage.removeItem("encounterid");
                    CommonComponents.patientId = 0;
                    CommonComponents.patientName = '';
                    this.bannerService.toggle(Number("-1"));
                    this.router.navigateByUrl('/Appointments');
                  }
                  else {
                    this.clearFieldsAfterSubmit();
                    // sessionStorage.setItem("LocationId", this.NewAppointmentForm.value.ServiceSite);
                    // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment', 1]));
                  }
                }
              });
          }
        }
      }
      else
        this.toastr.error("Template Deactivated.");

    }
  }


  onAppointmentCreateConformationDialog(message: string) {

    if (message != null && message != undefined) {
      if (message === 'Appointment already exists for this Patient with this provider') {
        if (this.fromfollowup)
          this.IsFollowupCreateApp = false;
        this.toastr.warning(message);
        return;
      }
    }
    var heightpx = '150px';
    if (message.includes('not of Active status')) {
      heightpx = "200px";
    }
    const dialogRef2 = this.dialog.open(ConfirmationDialogComponent, {
      width: '400px',
      height: heightpx,
      data: { headerText: message + '. Do you want to create new appointment ?' }
    });

    dialogRef2.afterClosed().subscribe(dialogResult => {

      if (dialogResult == true) {
        this.schedulerservice.insertAppointment(this.appointmentInfo, false).subscribe(
          results => {
            this.getActiveProcedures1();
            this.appResult = results;
            if (this.appResult.result === 'Appointment already exists for this Patient with this provider') {
              this.toastr.warning(this.appResult.result);
              return;
            }
            this.toastr.success(this.appResult.result);
            sessionStorage.setItem("appDate", this.NewAppointmentForm.value.AppointmentDate);
            if (this.fromProviderCal) {
              this.router.navigateByUrl('/ProviderCalender');
            }
            // else if (this.fromfollowup)
            //   this.router.navigateByUrl('/Follow-Up');
            else if (this.fromfollowup && this.IsFollowupCreateApp == false) {
              sessionStorage.setItem("followNextApp", "true");
              this.router.navigateByUrl('/Follow-Up');
            }
            else if (this.fromfollowup && this.IsFollowupCreateApp == true) {
              this.IsFollowUpScreen = true;
              //  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment']));
              //   this.onRefreshClick();
              this.clearFieldsAfterSubmit();
              if (this.btnText == "Modify Appointment") {
                this.apptitle = 'New Appointment';;
                this.btnText = 'Create Appointment';
              }
            }
            else if (this.screenName == "ReferralTracker") {
              this.router.navigateByUrl('/patientreferraltracker');
              sessionStorage.removeItem("screen");
            }
            else if (this.fromPatientPortal == 'Portal') {
              // this.router.navigate(['messageInbox']);
              this.router.navigate(['tasksandmessages/', 'BackToMessages']);
            } else if (sessionStorage.getItem("nextapp")) {
              sessionStorage.removeItem("patientId");
              sessionStorage.removeItem("patientName");
              sessionStorage.removeItem("encounterid");
              CommonComponents.patientId = 0;
              CommonComponents.patientName = '';
              this.bannerService.toggle(Number("-1"));
              this.router.navigateByUrl('/Appointments');
            }
            else {
              //siva
              if (sessionStorage.getItem("PatientBoardDefaultDate")) {
                sessionStorage.removeItem("patientId");
                sessionStorage.removeItem("patientName");
                sessionStorage.removeItem("encounterid");
                CommonComponents.patientId = 0;
                CommonComponents.patientName = '';
                this.bannerService.toggle(Number("-1"));
                this.router.navigateByUrl('/Appointments');
              }
              else {
                this.clearFieldsAfterSubmit();
                // sessionStorage.setItem("LocationId", this.NewAppointmentForm.value.ServiceSite);
                // this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => this.router.navigate(['/NewAppointment', 1]));
              }
            }

          });
      }
      else {
        if (this.IsFollowupCreateApp == true) {
          this.IsFollowupCreateApp = false;
        }
      }
    });
  }
  transform(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd/yyyy');
    }
    return value;
  }
  getBillingProviders() {
    this.schedulerservice.getBillingUsers().subscribe(data => {
      this.billingProviders = data;
    });
  }

  public selecteddate: string = "";
  mapFormValuesToAppointmentModel() {
    let datePipe1 = new DatePipe("en-US");
    this.appointmentInfo.phyName = this.lstProviders.filter(x => x.userId == this.NewAppointmentForm.value.RenderingProvider)[0].fullName;
    this.appointmentInfo.location = this.lstLocations.filter(x => x.locationId == this.NewAppointmentForm.value.ServiceSite)[0].locationName;
    this.appointmentInfo.startTime = this.NewAppointmentForm.value.StartTime;
    this.appointmentInfo.appStartTime = this.NewAppointmentForm.value.StartTime;
    this.appointmentInfo.physician = encodeURIComponent(this.NewAppointmentForm.value.RenderingProvider);
    this.appointmentInfo.visitId = this.NewAppointmentForm.value.VisitType;
    this.appointmentInfo.locationId = this.NewAppointmentForm.value.ServiceSite;
    this.appointmentInfo.roomId = this.NewAppointmentForm.value.Room;
    this.appointmentInfo.comments = this.NewAppointmentForm.value.Comments;
    this.appointmentInfo.ctdayId = this.selectedctdayId;
    this.appointmentInfo.start = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
    this.appointmentInfo.startTimeZoneId = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
    this.appointmentInfo.appointDate = datePipe1.transform(this.NewAppointmentForm.value.AppointmentDate, 'MM/dd/yyyy');
    this.starttimechk = this.NewAppointmentForm.value.StartTime.toUpperCase().trim();
    this.appointmentInfo.end = this.selectedEndDate;
    this.endtimechk = this.NewAppointmentForm.value.EndTime.toUpperCase().trim();
    this.appointmentInfo.patientId = CommonComponents.patientId;
    this.appointmentInfo.dbOperation = 'Insert';
    this.appointmentInfo.modifiedBy = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.appointmentInfo.createdby = encodeURIComponent(sessionStorage.getItem("userId")).toString();
    this.appointmentInfo.facilityId = Number(sessionStorage.getItem("FacilityId"));
    this.appointmentInfo.Id = Guid.create().toString();
    this.appointmentInfo.supervisorProvider = encodeURIComponent(this.NewAppointmentForm.value.SuperVising);
    this.appointmentInfo.billingProvider = this.NewAppointmentForm.value.BillingProvider;
    this.appointmentInfo.procedureName = this.Selectedcode;
    this.appointmentInfo.ctdayId = this.selectedctdayId;
    this.appointmentInfo.locTwillioPhoneNum = encodeURIComponent($("#selectID option:selected").data("target"));
    if (this.selectedctdayId == -1) {
      this.appointmentInfo.startTime = this.slotinsertstarttime;
      this.appointmentInfo.endTime = this.slotinsertendtime;
    }
    this.appointmentInfo.notesDetails = this.NewAppointmentForm.value.notesComments;
    this.appointmentInfo.patientName = this.NewAppointmentForm.value.PatientName;
    if (this.screenName == "ReferralTracker") {
      this.appointmentInfo.screen = "ReferralTracker";
    } else if (this.fromPatientPortal == 'Portal') {
      this.appointmentInfo.screen = "PatientPortal";
      this.appointmentInfo.PPRequestId = Number(this.PatientPortalId);
    } else {
      this.appointmentInfo.screen = "";
    }

    if (sessionStorage.getItem("role") == "Doctor") {
      this.appointmentInfo.isProvider = true;
    }
    else if (sessionStorage.getItem("role") == "Nurse") {
      this.appointmentInfo.isNurse = true;
    } else {
      this.appointmentInfo.isProvider = true;
      this.appointmentInfo.isNurse = false;
    }
  }
  public slotduration: string;
  isvtypeChange: boolean = false;
  teleobj: IVisitTypes[] = []
  onVisitChange() {
    let telObj = this.lstVistTypes.filter(x => x.visitId == this.NewAppointmentForm.value.VisitType);
    if (telObj != null && telObj != undefined) {
      if (telObj[0].isTelemedicine == true) {
        if (this.patEmailId == "" && this.patCellPhone == "") {
          this.toastr.warning("Telemedicine Details cannot be sent as both Patient's Primary Email & Cell Phone number are unavailable.");
        } else if (this.patEmailId == "") {
          this.toastr.warning("Telemedicine Details shall be sent to Patient's Cell Phone Number only as Primary Email is unavailable.");
        } else if (this.patCellPhone == "") {
          this.toastr.warning("Telemedicine Details shall be sent to Patient's Primary Email only as Cell Phone number is unavailable.");
        }
      }
    }
    this.selectedctdayId = 0;
    this.isvtypeChange = true;
    this.getAvailableSlotsByDate();
    this.slotduration = this.lstVistTypes.filter(x => x.visitId == this.NewAppointmentForm.value.VisitType)[0].visitDuration;
    this.NewAppointmentForm.patchValue({
      Duration: this.slotduration
    });
    this.cleartime();
    this.IsSlotfromTemplete = true;
    this.initilizeCalender();
    //   var selectedProvider = this.NewAppointmentForm.value.RenderingProvider
    //   var selectedVisitType = this.NewAppointmentForm.value.VisitType
    //   var selectedLocation = this.NewAppointmentForm.value.ServiceSite
    //   var selectedappDate = this.NewAppointmentForm.value.AppointmentDate
    //   if ((selectedProvider != undefined || selectedProvider != null) && (selectedVisitType != undefined || selectedVisitType != null) &&
    //     (selectedLocation != undefined || selectedLocation != null) && (selectedappDate != undefined || selectedappDate != null)) {
    //   this.toastr.warning(this.NewAppointmentForm.value.VisitType);
    //     //  this.getCalenderByDate();
    //     this.getAvailableSlotsByDate();
    //   }
    // if(this.NewAppointmentForm.value.VisitType !=null && this.NewAppointmentForm.value.VisitType !=undefined && this.NewAppointmentForm.value.VisitType!='')
    // {
    //   this.NewAppointmentForm.patchValue(
    //     {
    //       Duration: this.lstVistTypes.filter(x=>x.visitId ==  this.NewAppointmentForm.value.VisitType)[0].visitDuration
    //     }
    //   );
    // }
    //  this.timeChanged(visit.visitDuration);
  }

  timeChanged(event) {                                  // Time Change

    var time = event;
    var splitColumn = '';
    var hours = '';
    var array = '';
    var minutes = 0;
    var AmPm = '';
    var duration = 0;
    var addMinutes = 0;
    var total = '';
    var totHrs = 0;
    var totMinutes = 0;

    if (time.length > 2) {                            // on change Visit Type Duration length 2 digits
      splitColumn = time.split(':');
      hours = splitColumn[0];
      if (hours == "00") {
        hours = "12";
      }
      array = splitColumn[1];
      var splitSpace = array.split(' ');
      minutes = Number(splitSpace[0]);
      AmPm = splitSpace[1].toUpperCase().trim();
      duration = Number(this.NewAppointmentForm.get('Duration').value);
      addMinutes = minutes + duration;

      if (addMinutes > 59) {                         // Minutes above 59

        totHrs = (Number(hours) + 1);
        totMinutes = Number(addMinutes - 60);
        var min = totMinutes;
        if (totHrs >= 13 && AmPm == 'PM') {
          AmPm = 'PM'
          if (totHrs == 13) {
            totHrs = 1;
          }
        }
        //else {
        //   AmPm = 'AM'
        //   if (totHrs == 13) {
        //     totHrs = 1;
        //   }
        // }
        //   if (min.toString().length == 1) {
        //     min = "0" + min.toString();
        // }

        if (totHrs < 12 && AmPm == 'PM') {
          //if (totHrs <= 12 && AmPm == 'PM' && min != 0) {
          var hrs = Number(totHrs - 12) + 1;

          // if (AmPm == 'AM') {
          AmPm = 'PM'
          //   //total = (totHrs + ':' + min + ' ' + addAmPm).toString();
          // }
          // else {
          //    AmPm = 'PM'
          //   //total = (totHrs + ':' + min + ' ' + addAmPm).toString();
          // }
        }
        // else {
        //   AmPm = 'AM'
        //   if (totHrs == 13) {
        //     totHrs = 1;
        //   }
        //  }

        total = (totHrs + ':' + min + ' ' + AmPm).toString();

      } else {
        total = (hours + ':' + addMinutes + ' ' + AmPm).toString();

      }

      this.NewAppointmentForm.patchValue(
        {
          EndTime: total,
        }
      );
    }
    else {                                           // On Change Start Time
      var addDuration = Number(time);
      var startTime = this.NewAppointmentForm.get('StartTime').value;
      splitColumn = startTime.split(':');
      hours = splitColumn[0];
      if (hours == "00") {
        hours = "12";
      }


      array = splitColumn[1];
      splitSpace = array.split(' ');
      minutes = Number(splitSpace[0]);
      AmPm = splitSpace[1].toUpperCase().trim();
      addMinutes = minutes + addDuration;
      if (addMinutes > 59) {
        totHrs = Number(hours) + 1;
        totMinutes = Number(addMinutes - 60);
        var min = totMinutes;
        if (totHrs >= 12) {
          if (totHrs == 13) {
            totHrs = 1;
          }
          var hrs = Number(totHrs - 12) + 1;
          if (AmPm == 'AM') {
            var addAmPm = 'AM'

            total = (totHrs + ':' + min + ' ' + addAmPm).toString();
          }
          else {
            var addAmPm = 'PM'

            total = (totHrs + ':' + min + ' ' + addAmPm).toString();
          }

        }
        else {
          total = (totHrs + ':' + min + ' ' + AmPm).toString();

        }

      } else {
        total = (hours + ':' + addMinutes + ' ' + AmPm).toString();

      }
      this.NewAppointmentForm.patchValue(
        {
          EndTime: total,
        }
      );
    }

  }
  public calendar: any;
  ngAfterViewInit() {
    this.initilizeCalender();
  }

  initilizeCalender() {
    // this.ini_events($('#external-events div.external-event'));
    var self = this;
    var Calendar = FullCalendar.Calendar;
    var Draggable = FullCalendarInteraction.Draggable;

    var containerEl = document.getElementById('external-events');
    var checkbox = document.getElementById('drop-remove');
    var calendarEl = document.getElementById('calendar');
    $(calendarEl).html('');
    let defaultDate = new Date();
    this.calendar = new Calendar(calendarEl, {
      plugins: ['bootstrap', 'interaction', 'dayGrid', 'timeGrid'],
      header: false,
      defaultView: this.calenderView,
      defaultDate: this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd'),
      contentHeight: 'auto',
      'themeSystem': 'bootstrap',
      allDaySlot: false,
      events: this.eventsData,
      slotduration: '00:15:00',
      slotLabelInterval: 15,
      editable: false,
      selectable: true,
      dateClick: this.handleDateClick.bind(this),
      // select: this.handleDateSelect.bind(this),
      eventClick: this.handleEventClick.bind(this),
      //  dateClick: function(info) {
      //   alert('clicked ' + info.dateStr + ' on resource ');
      //  this.handleDateSelect.bind(this);
      // },
      //  eventMouseEnter: function (info) {
      //  // $(info.el).tooltip({ title: info.event.title });


      // },
      eventRender: function (info) {

        if (info.event.extendedProps.ctdayId == Number(self.selectedctdayId) && self.selectedctdayId != -1) {
          self.ElementPreviousColor = info.event.backgroundColor;
          self.PreviousClickedEvent = info;
          if (info.event.extendedProps.visitTypeId != '0')
            info.el.style.backgroundColor = 'yellow';
        }
        else if (self.selectedAppointment != null && self.selectedAppointment != undefined && self.selectedctdayId == -1 && info.event.extendedProps.patName.toUpperCase() == self.selectedAppointment.name.toUpperCase()) {
          self.ElementPreviousColor = info.event.backgroundColor;
          self.PreviousClickedEvent = info;
          if (info.event.extendedProps.visitTypeId != '0')
            info.el.style.backgroundColor = 'yellow';
        }
        // if(info.event.backgroundColor == "#cecece"){
        //   info.el.style.pointerEvents = "none";
        // }

        let e = $(info.el);
        let text = e.find('.fc-title').text();
        if (info.event.extendedProps.patName != '')
          e.find('.fc-title').text(info.event.title + "   " + info.event.extendedProps.patName + "\n" + info.event.extendedProps.dob);

        $(info.el).attr("data-toggle", "tooltip")
        $(info.el).attr("title", info.event.extendedProps.patName + "\n" + info.event.extendedProps.dob + "\n" + info.event.extendedProps.providerName)
        if (info.event.title == 'null')
          $(info.el).find('.fc-title').text('Block');
        $(info.el).mousedown(function (ev) {
          if (ev.which == 3) {
            //  alert("Right mouse button clicked on element with id myId");
          }
        });

      },

      //  eventClick: function (calEvent, jsEvent, view) {
      //    alert('hello you clicked on slot :: ' + calEvent.el.children[0].innerText);
      //    var selectedVisit = calEvent.el.children[0].innerText.toString().substring(12).replace(/\s/g, "");
      //  // this.findElement(selectedVisit);
      //   window.myFunc(calEvent);
      //  },
      slotEventOverlap: false,
      droppable: true, // this allows things to be dropped onto the calendar !!!
      slotDuration: (this.currentLocation != null ? ("00:" + (this.currentLocation.slotTimeDuration < 10 ? ("0" + this.currentLocation.slotTimeDuration) : this.currentLocation.slotTimeDuration) + ":00") : "00:15:00"),// "00:15:00",
      minTime: (this.currentLocation != null ? this.currentLocation.start : "01:00:00"),
      maxTime: (this.currentLocation != null ? this.currentLocation.end : "23:30:00"),
      // minTime: "07:00:00",
      //  maxTime: "19:00:00",
      drop: function (info) {
      }

    });
    this.calendar.render();
  }
  public selectedctdayId: number;
  public selectedStartTime: string;
  public selectedStartDate: string;
  public selectedEndDate: string;
  public selectedEndTime: string;
  ElementPreviousColor: any
  PreviousClickedEvent: any
  oldclickinfo: any
  iscancel: boolean = false;
  handleEventClick(clickInfo) {

    if (clickInfo.event.extendedProps.visitTypeId == 0 || clickInfo.event.extendedProps.patName != '')
      return;
    if (clickInfo.event.extendedProps.providerId != "" && clickInfo.event.extendedProps.locationId != 0 && clickInfo.event.extendedProps.visitTypeId != "") {
    } else {
      this.toastr.warning("cant update or reschedule this appointment");
      this.clearVisit();
      return;
    }

    let telObj = this.lstVistTypes.filter(x => x.visitId == clickInfo.event.extendedProps.visitTypeId);
    if (telObj != null && telObj != undefined) {
      if (telObj[0].isTelemedicine == true) {
        if (this.patEmailId === "") {
          this.toastr.error("Please Give Email At Patient Information");
          //return;
        }
      }
    }
    var startDate = moment(clickInfo.event.start).toDate();
    if (this.ElementPreviousColor == (null || undefined) && this.PreviousClickedEvent == (null || undefined)) {
      this.ElementPreviousColor = clickInfo.event.backgroundColor;
      this.PreviousClickedEvent = clickInfo;
      clickInfo.el.style.backgroundColor = 'yellow';
    }
    else {
      this.oldclickinfo = this.PreviousClickedEvent;
      this.PreviousClickedEvent.el.style.backgroundColor = this.ElementPreviousColor
      this.ElementPreviousColor = clickInfo.event.backgroundColor;
      this.PreviousClickedEvent = clickInfo;
      clickInfo.el.style.backgroundColor = 'yellow';
    }
    var startTime = this.transformTimeFormat(startDate.getHours(), startDate.getMinutes());
    var splitColon = startTime.split(':');
    var starthour = splitColon[0];
    var startmin = splitColon[1];
    if (starthour == "00") {
      startTime = 12 + ":" + startmin;
    }
    var end_Date = moment(clickInfo.event.end).toDate();
    var end_Time = this.transformTimeFormat(end_Date.getHours(), end_Date.getMinutes());
    var selectedItem = this.calenderEvents.find(x => x.title == clickInfo.event.title && (x.CTDayId == clickInfo.event.extendedProps.ctdayId) && (moment(x.startTime).toDate().getHours() == startDate.getHours() && moment(x.startTime).toDate().getMinutes() == startDate.getMinutes()));
    if (selectedItem.CTDayId == -1) {
      this.toastr.warning("This is a custom slot.Please select another");
      return;
    }

    if ((this.NewAppointmentForm.value.VisitType != selectedItem.visitTypeId.toString()) && this.NewAppointmentForm.value.VisitType != null && this.NewAppointmentForm.value.VisitType != "undefined" && this.NewAppointmentForm.value.VisitType != undefined && this.NewAppointmentForm.value.VisitType != "" && this.iscancel == false) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '400px',
        height: '160px',
        data: { headerText: 'There is a mismatch in the Visit Type you have selected. Please click on Ok button to change the Visit Type and proceed further.' }
      });

      dialogRef.afterClosed().subscribe(result => {

        if (result == true) {
          this.isvtypeChange = false;
          if (selectedItem != null && selectedItem != undefined && selectedItem.isScheduled == false) {
            this.NewAppointmentForm.patchValue({
              VisitType: selectedItem.visitTypeId.toString(),
              StartTime: startTime,
              EndTime: end_Time,
              AppointmentDate: selectedItem.startTime,
              Duration: this.lstVistTypes.filter(x => x.visitId.toString() == selectedItem.visitTypeId.toString())[0].visitDuration.toString()
            });
            this.selectedctdayId = selectedItem.CTDayId;
            this.selectedStartTime = startTime;
            this.selectedEndTime = end_Time;
            this.selectedStartDate = selectedItem.startTime;
            this.selectedEndDate = selectedItem.endTime;
            this.IsSlotfromTemplete = false;
            this.getAvailableSlotsByDate();
          }
        } else {
          if (this.isvtypeChange) {
            this.oldclickinfo = this.PreviousClickedEvent;
            this.PreviousClickedEvent.el.style.backgroundColor = this.ElementPreviousColor
            this.ElementPreviousColor = clickInfo.event.backgroundColor;
            this.PreviousClickedEvent = clickInfo;
            clickInfo.el.style.backgroundColor = this.ElementPreviousColor;
          } else {
            this.isvtypeChange = false;
            this.iscancel = true;
            this.handleEventClick(this.oldclickinfo);
          }
        }
      });
    }
    else {
      if (selectedItem != null && selectedItem != undefined && selectedItem.isScheduled == false) {
        this.iscancel = false;
        this.IsSlotfromTemplete = false;
        this.NewAppointmentForm.patchValue({
          VisitType: selectedItem.visitTypeId.toString(),
          StartTime: startTime,
          EndTime: end_Time,
          AppointmentDate: selectedItem.startTime,
          Duration: this.lstVistTypes.filter(x => x.visitId.toString() == selectedItem.visitTypeId.toString())[0].visitDuration.toString()
        });
        this.selectedctdayId = selectedItem.CTDayId;
        this.selectedStartTime = startTime;
        this.selectedEndTime = end_Time;
        this.selectedStartDate = selectedItem.startTime;
        this.selectedEndDate = selectedItem.endTime;
        this.getAvailableSlotsByDate();
      }
    }
  }

  handleDateSelect(clickInfo) {
    //   alert("select called"+clickInfo.event);
    alert("handle date " + clickInfo.event);
    alert("date " + clickInfo.dateStr);
  }

  handleDateClick(arg) {
    // alert("Do you want to block the da "+arg.dateStr);
    // if (confirm("Do you want to block the appointments on  " + arg.dateStr)) {
    //   alert("yes");
    //   this.schedulerservice.blockAppointmentbyDate(this.NewAppointmentForm.value.RenderingProvider, arg.dateStr)
    //     .subscribe(() => {
    //       this.getByMonth();
    //       this.getBlockedAppointments();
    //     });
    // }
  }
  ini_events(ele) {
    ele.toArray().forEach(function (_e, i) {
      // create an Event Object (http://arshaw.com/fullcalendar/docs/event_data/Event_Object/)
      // it doesn't need to have a start or end
      var eventObject = {
        title: $.trim($(_e).text()) // use the element's text as the event title
      }

      // store the Event Object in the DOM element so we can get to it later
      $(_e).data('eventObject', eventObject)

      // make the event draggable using jQuery UI
      $(_e).draggable({
        zIndex: 1070,
        revert: true, // will cause the event to go back to its
        revertDuration: 0  //  original pocalendarsition after the drag
      });
    });

  }

  async getActiveProcedures() {
    this.procService.getActiveProcedures(CommonComponents.patientId).subscribe(async data => {
      await data;
      this.activeProcedures = data;
      if (this.selectedAppId != null && this.selectedAppId != undefined && this.selectedAppId != 'undefined')
        this.getAppointmentbyId(data);
    });
  }
  getActiveProcedures1() {
    this.procService.getActiveProcedures(CommonComponents.patientId).subscribe(data => {
      this.activeProcedures = data;
    })
  }
  currDate: any; chkslotdate: any;
  public calenderEvents: CalendarTemplateDay[];
  public currentLocation: ILocationDetails;
  public blockdayMsg: string = '';
  getCalenderByDate(selectedDate?: any) {
    // alert('dd');

    this.datepipe = new DatePipe("en-US");
    this.ElementPreviousColor = null;
    this.PreviousClickedEvent = null;
    //alert("providerId"+ this.NewAppointmentForm.value.RenderingProvider);
    //sessionStorage.setItem("providerid", this.NewAppointmentForm.value.RenderingProvider);

    if (selectedDate != null && selectedDate != undefined && selectedDate != '') {
      this.currDate = this.datepipe.transform(selectedDate, 'yyyy-MM-dd');
      // sessionStorage.setItem("changedDate", this.currDate);
      this.slotduration = this.NewAppointmentForm.value.Duration;
    }
    else
      this.currDate = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
    //sessionStorage.setItem("changedDate", this.currDate);
    this.chkslotdate = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
    this.slotduration = this.NewAppointmentForm.value.Duration;
    if (this.currDate != '' && this.currDate != undefined && this.NewAppointmentForm.value.RenderingProvider != undefined && this.NewAppointmentForm.value.ServiceSite != undefined && this.NewAppointmentForm.value.RenderingProvider != '' && this.NewAppointmentForm.value.ServiceSite != '') {
      this.calendar.render()
      this.eventsData = [];
      this.schedulerservice.getProviderHolidays(this.NewAppointmentForm.value.RenderingProvider, this.currDate, this.NewAppointmentForm.value.ServiceSite).subscribe((events: boolean) => {
        var isholiday = events;
        if (!isholiday) {
          if (this.chkslotdate == this.currDate) {
            this.IsSlotfromTemplete = true;
          }
          this.blockdayMsg = '';
          ;
          this.schedulerservice.getCalendarTemplateByDate(this.NewAppointmentForm.value.RenderingProvider, this.currDate, this.NewAppointmentForm.value.ServiceSite)
            .subscribe((events: CalendarTemplateDay[]) => {
              this.calenderEvents = [];
              this.eventsData = [];
              this.calenderEvents = events;
              if (this.calenderEvents != null && this.calenderEvents != undefined) {
                if (this.calenderEvents.length > 0) {
                  this.isTemplateActive = this.calenderEvents[0].isActive;
                }
              }
              events.forEach(element => {
                var obj = {
                  title: element.title,
                  //  content: 'content',
                  start: element.startTime.toString(),
                  end: element.endTime.toString(),
                  backgroundColor: element.backgroundColor,
                  borderColor: '#ccc',
                  pointerevents: element.backgroundColor == "#cecece" ? "none" : "visible",
                  extendedProps: {
                    visitTypeId: element.visitTypeId,
                    patName: element.patName,
                    dob: element.dob,
                    providerName: element.providerName,
                    ctdayId: element.CTDayId,
                    id: element.id,
                    encounterId: element.encounterId,
                    providerId: element.providerId,
                    locationId: element.locationId,
                  },
                };
                this.eventsData.push(obj);

              });
              if (this.lstLocations != null && this.lstLocations != undefined)
                this.currentLocation = this.lstLocations.find(loc => loc.locationId.toString() == this.NewAppointmentForm.value.ServiceSite.toString());
              this.initilizeCalender();
              this.calendar.gotoDate(this.datePipe.transform(this.currDate, "yyyy-MM-dd"));
              this.calendarHeaderDate = this.datePipe.transform(this.currDate, "yyyy-MM-dd");

              if (this.NewAppointmentForm.value.VisitType != null && this.NewAppointmentForm.value.VisitType != undefined && this.NewAppointmentForm.value.VisitType != '') {
                if (this.arrowchange == false) {
                  this.getAvailableSlotsByDate();
                }
              }
            });
        } else {
          // this.blockdayMsg = "This day was block day";
          this.blockdayMsg = "Provider has blocked this day";

          if (this.blockdayMsg == "Provider has blocked this day") {
            if (this.chkslotdate == this.currDate) {
              this.IsSlotfromTemplete = false;
            }
          }
          this.initilizeCalender();
          this.calendarHeaderDate = this.datePipe.transform(this.currDate, "yyyy-MM-dd");
        }
      });
    }
    else
      { }
    this.getRoomsbyLocation();

  }
  getlocationbasedproviders() {
    ;
    // alert( this.selectedProviderId);
    // alert('test');
    // alert(this.NewAppointmentForm.value.ServiceSite);
    this.NewAppointmentForm.controls['RenderingProvider'].setValue('');
    if (this.selectedLocationId != 0 && this.selectedvisitTypeId != 0 && this.selectedProviderId != null && this.selectedProviderId != undefined && this.selectedProviderId != "undefined") {
      if (this.selectedctdayId != 0) {
        this.NewAppointmentForm.patchValue({
          RenderingProvider: this.appPhysician
        });
      }
    }
    this.sharedService.getselectedlocidByrole(Defaults.doctorType, Number(this.NewAppointmentForm.value.ServiceSite)).subscribe(async data => {
      ;
      this.lstProviders = [];
      // this.lstProvider = [];
      this.supervisingProviders = [];
      this.lstProviders = data;
      this.lstProviders.unshift(new IUserDetails());
      //this.lstProvider = data;
      // alert(this.router.url);
      //this.NewAppointmentForm.controls['RenderingProvider'].setValue(this.lstProviders[0].userId);
      var geturl = this.router.url;
      if (geturl.includes("1")) {
        // alert("inside"+sessionStorage.getItem('providerid') );
        //  alert("providerId:")
        //alert( this.appPhysician);
        if (this.appPhysician != "" && sessionStorage.getItem('providerid') != 'null' && sessionStorage.getItem('providerid') != null && sessionStorage.getItem('providerid') != undefined && sessionStorage.getItem('providerid') != '' && sessionStorage.getItem('providerid') != "") {
          // var filterprovider = this.lstProviders.filter(d => d.userId === sessionStorage.getItem('providerid'));
          var filterprovider = this.lstProviders.filter(d => d.userId === this.appPhysician);
          if (filterprovider.length > 0 && filterprovider != null) {
            // alert(filterprovider[0].userId);
            this.NewAppointmentForm.patchValue({
              RenderingProvider: filterprovider[0].userId
            });
            this.appPhysician = "";
            // sessionStorage.setItem('providerid',null);
            // alert("2-" + this.selectedProviderId);
            //this.selectedProviderId=sessionStorage.getItem('providerid');
            // alert("appdate"+sessionStorage.getItem('appDate'));
            if (sessionStorage.getItem('appDate') != 'null' && sessionStorage.getItem('appDate') != null && sessionStorage.getItem('appDate') != undefined && sessionStorage.getItem('appDate') != 'undefined') {

              var datePipe = new DatePipe("en-US");
              var changeddate = datePipe.transform(sessionStorage.getItem('appDate'), "yyyy-MM-dd");
              this.NewAppointmentForm.patchValue({
                AppointmentDate: moment(changeddate).toDate()
              });
              this.currentAppDate = this.NewAppointmentForm.value.AppointmentDate;
              this.getCalenderByDate(this.currentAppDate);
            }
            else {
              //sessionStorage.setItem('changedDate', null);
            }
          }
        }
        this.isalert = geturl.split('/')[2];
      }
      else {
        //alert("selected app"+this.selectedAppId);
        if (this.selectedAppId == null)
          sessionStorage.setItem('providerid', null);
        // sessionStorage.setItem('changedDate', null);
      }
      // this.lstProvider =data;
      if (this.fromPatientPortal == 'Portal') {
        this.NewAppointmentForm.patchValue({
          ServiceSite: this.selectedPPLocationId,
          RenderingProvider: this.selectedProviderId,
        });
      }
      this.supervisingProviders = data;
      if (this.lstLocations != null && this.lstLocations != undefined)
        this.currentLocation = this.lstLocations.find(loc => loc.locationId.toString() == this.NewAppointmentForm.value.ServiceSite.toString());
      this.initilizeCalender();
      // alert(this.currDate); alert(this.NewAppointmentForm.value.AppointmentDate);
      this.calendar.gotoDate(this.datePipe.transform(this.currDate, "yyyy-MM-dd"));
      this.currentAppDate = this.NewAppointmentForm.value.AppointmentDate;
      this.getCalenderByDate(this.datePipe.transform(this.currDate, "yyyy-MM-dd"));
    });
  }

  public availableSlotsList: IAvailableSlots[];
  async getAvailableSlotsByDate() {
    this.availableSlot = [];
    if (this.NewAppointmentForm.value.VisitType && this.NewAppointmentForm.value.VisitType != ''
      && this.NewAppointmentForm.value.RenderingProvider != '') {
      this.bannerService.toggle(sessionStorage.getItem("patientId"));
      this.currDate = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
      await this.schedulerservice.getAvailableSlotsByDate(this.NewAppointmentForm.value.RenderingProvider, this.NewAppointmentForm.value.ServiceSite, this.currDate, this.NewAppointmentForm.value.VisitType)
        .subscribe((events: IAvailableSlots[]) => {
          this.availableSlotsList = events;
          this.availableSlot = [];
          if (this.availableSlotsList) {
            for (let i = 0; i < this.availableSlotsList.length; i++) {
              let v = new Availlist;
              v.shortDate = this.transforms(this.availableSlotsList[i].currDate.toString());
              v.noofSlots = this.availableSlotsList[i].noofSlots;
              v.currDate = this.availableSlotsList[i].currDate;
              this.availableSlot.push(v);
            }
          }
        });
    }
  }
  async getAvailableSlotsByDate1() {
    this.availableSlot = [];
    if (this.selectedAppointment.visitType && this.selectedAppointment.visitType != ''
      && this.selectedAppointment.physician != '') {
      this.bannerService.toggle(sessionStorage.getItem("patientId"));
      this.currDate = this.datepipe.transform(this.NewAppointmentForm.value.AppointmentDate, 'yyyy-MM-dd');
      await this.schedulerservice.getAvailableSlotsByDate(this.selectedAppointment.physician, this.selectedAppointment.locationId, this.currDate, this.selectedAppointment.visitId)
        .subscribe((events: IAvailableSlots[]) => {
          this.availableSlotsList = events;
          this.availableSlot = [];
          if (this.availableSlotsList) {
            this.availableSlotsList.forEach(element => {
              let v = new Availlist;
              v.shortDate = this.transforms(element.currDate.toString());
              v.noofSlots = element.noofSlots;
              v.currDate = element.currDate;
              this.availableSlot.push(v);
            });
          }
        });
    }
  }
  transforms(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'MM/dd');
    }
    return value;
  }
  findElement(selectedItem: any) {
  }
  transformTimeFormat(hour: any, min: any): any {
    let part = hour >= 12 ? 'pm' : 'am';
    min = (min + '').length == 1 ? `0${min}` : min;
    hour = hour >= 12 ? hour - 12 : hour;
    hour = (hour + '').length == 1 ? `0${hour}` : hour;
    return `${hour}:${min} ${part}`
  }
  remarkComment: string = ''
  OpenRemarks(value: string): void {
    var splitted = this.NewAppointmentForm.value.Comments;
    const dialogRef = this.dialog.open(RemarksComponent, {
      width: '800px',
      height: '420px',
      data: { Comments: splitted, adminUser: sessionStorage.getItem("userId").toString() }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.remarkComment = result;
        this.NewAppointmentForm.patchValue({
          Comments: result,
        });
      }
      // else{
      //   this.NewAppointmentForm.patchValue({
      //     Comments: '',
      //   });
      // }
    });
  }

  OpenDate(): void {
    const dialogRef = this.dialog.open(DateDialogComponent, {
      width: '400px',
      height: '120px',
      data: { AppointmentDate: this.NewAppointmentForm.controls["AppointmentDate"].value }

    });
    dialogRef.afterClosed().subscribe(result => {
      if (result != null && result != undefined) {

        this.clearVisit();
        var datePipe = new DatePipe("en-US");
        var popupdate = datePipe.transform(result, "yyyy-MM-dd");
        this.NewAppointmentForm.patchValue({
          AppointmentDate: moment(popupdate).toDate(),
        });
        //  this.NewAppointmentForm.controls['AppointmentDate'].setValue(new Date(popupdate));
        this.getCalenderByDate(popupdate);
        this.calendarHeaderDate = datePipe.transform(popupdate, "yyyy-MM-dd");
      }
    });
  }


  getByDay() {
    this.calenderView = 'timeGridDay';
    this.initilizeCalender();
  }

  tempApp: any;
  appointment: IAppointmentData;
  userlist: string = "";
  blockedAppointment: IAppointmentData[] = [];
  getBlockedAppointments() {

    this.blockedAppointments = [];
    if (this.worklistdrp == false) {
      this.userlist = "";
      //TO DO
      //this.locID = 0;
    }
    else {
      //this.userlist = this.NewAppointmentForm.value.worklistprovider;
      this.userlist = this.selectedProviderList;
      //TO DO
      // this.locID = this.NewAppointmentForm.value.worklistlocation;
    }
    this.schedulerservice.getBlockedAppointments(this.userlist, this.locID).subscribe(data => {

      this.blockedAppointment = data;
      if (this.blockedAppointment.length == 0) {
        this.noShowMessage = 'No Result Found.'
      } else {
        this.noShowMessage = '';
      }
      if (data) {
        for (let i = 0; i < data.length; i++) {
          let v = new BlockedAppointment;
          v.Id = data[i].Id;
          v.patName = data[i].patientName;
          v.phone = data[i].homePhone;
          v.physician = data[i].physician;
          v.appDate = this.datePipe.transform(data[i].start, "MM/dd/yyyy");
          if (data[i].statusColor && data[i].statusColor != "")
            v.color = data[i].statusColor;
          // if (data[i].duration && Number(data[i].duration) > 0) {
          //   let hours = 0;
          //   let mins = Number(data[i].duration);
          //   if (mins >= 60) {
          //     hours = Math.floor(mins / 60);
          //     mins = mins - (hours * 60);
          //   }
          //   v.duration = hours.toString().padStart(2, '0').concat(':').concat(mins.toString().padStart(2, '0'));
          //   if (data[i].visitType && data[i].visitType != "")
          //     v.visitTypeText = data[i].visitType.concat(' ').concat(data[i].duration).concat(' minutes');
          //   v.allowResize = false;
          // }
          // else {
          //   v.duration = '00:15';
          //   if (data[i].visitType && data[i].visitType != "")
          //     v.visitTypeText = data[i].visitType;
          //   v.allowResize = true;
          // }

          this.blockedAppointments.push(v);
        }
      }
    },
      error => {
      });
    this.schedulerservice.getExportExcelApptworklist(this.userlist, this.locID).subscribe(data => {
      this.ApptWorklist = data;
    });
  }

  public arrowchange: boolean = false;
  Previous() {

    //this.clearVisit();
    this.arrowchange = true;
    this.currentAppDate = moment(this.calendarHeaderDate).toDate();
    this.currentAppDate.setDate(moment(this.calendarHeaderDate).toDate().getDate() - 1);
    // this.NewAppointmentForm.patchValue({
    //   AppointmentDate: this.currentAppDate
    // });
    // sessionStorage.removeItem('changedDate');
    // sessionStorage.setItem('changedDate',this.currentAppDate.toString());
    this.getCalenderByDate(this.currentAppDate);
    this.calendarHeaderDate = this.datePipe.transform(this.calendarHeaderDate, "yyyy-MM-dd");
  }

  Next() {

    //this.clearVisit();
    this.arrowchange = true;
    this.currentAppDate = moment(this.calendarHeaderDate).toDate();
    this.currentAppDate.setDate(moment(this.calendarHeaderDate).toDate().getDate() + 1);
    // this.NewAppointmentForm.patchValue({
    //   AppointmentDate: this.currentAppDate
    // });
    // sessionStorage.removeItem('changedDate');
    // sessionStorage.setItem('changedDate',this.currentAppDate.toString());
    this.getCalenderByDate(this.currentAppDate);
    this.calendarHeaderDate = this.datePipe.transform(this.calendarHeaderDate, "yyyy-MM-dd");
  }
  locationdisable = false;
  selectedAppointment: IAppointmentData;
  getAppointmentbyId(procedureData: any) {

    this.schedulerservice.getAppointmentbyId(this.selectedAppId).subscribe(
      results => {
        this.selectedAppointment = results;
        this.selectedctdayId = this.selectedAppointment.ctdayId;
        this.selectedStartDate = this.selectedAppointment.start;
        this.selectedEndDate = this.selectedAppointment.end;
        //this.selectedStartTime =  this.selectedAppointment.startTime;
        //this.selectedEndTime =  this.selectedAppointment.endTime;
        this.apptitle = 'Modify Appointment';
        this.btnText = 'Modify Appointment';
        //this.locationdisable=true;

        if (this.selectedAppointment.visitType != null && this.selectedAppointment.visitType != undefined && this.selectedAppointment.visitType != '') {
          if (this.arrowchange == false) {
            this.getAvailableSlotsByDate1();
          }
        }
        var procedure = this.selectedAppointment.ProcedureName;
        this.chk = this.selectedAppointment.ProcedureName;
        this.Selectedcode = this.selectedAppointment.ProcedureName;
        var procedure_array = procedure.split('#');
        if (procedure_array[0] != "" && procedureData != null) {
          if (procedureData.length == 0 && procedure_array.length > 0) {
            var obj: IprocedureCode;
            procedure_array.forEach(element => {
              obj = {
                cptMasterId: '',
                categoryId: null,
                categoryName: '',
                regionid: null,
                customerdescription: element,
                cliniciandescription: '',
                cptCode: '',
                icdCode: '',
                cptId: null,
                createdBy: '',
                createdOn: null,
                modifiedBy: '',
                aliasName: '',
                modifiedOn: null,
                procedureName: element,
                diagnosis: '',
                categoryCodes: null,
                icdCodes: null,
                selected: false
              }
              this.activeProcedures.push(obj)
            });
          }
        }

        // if (procedure_array !== null && procedure_array !== undefined) {
        //   if (procedure_array.length > 0) {
        //     procedure_array.forEach(eleproc => {
        //       var i = 0;
        //       if (eleproc !== "") {
        //         var sepLst = this.activeProcedures.filter(x => x.customerdescription == eleproc);
        //         if (sepLst !== null && sepLst !== undefined) {
        //           if (sepLst.length > 0) {
        //             this.activeProcedures[i].selected = true;

        //           } else {
        //             var tempProcude: IprocedureCode = new IprocedureCode();
        //             tempProcude.customerdescription = eleproc;
        //             this.activeProcedures.push(tempProcude);
        //           }
        //         }
        //       }

        //     });
        //   } else {

        //   }
        // }
        // for (var i = 0; i < procedure_array.length; i++) {
        //   procedure_array[i] = procedure_array[i].replace(/^\s*/, "").replace(/\s*$/, "");
        //   this.NewAppointmentForm.patchValue({
        //     FinanceCenter: procedure_array,
        //   });
        // }

        const procdureSplit = this.selectedAppointment.ProcedureName.split('#');
        var obj1: IprocedureCode;
        if (procdureSplit[0] != '' && procdureSplit) {
          for (var j = 0; j < procdureSplit.length; j++) {
            var lst = this.activeProcedures.filter(y => y.customerdescription === procdureSplit[j]);
            if (lst.length === 0) {
              obj1 = {
                cptMasterId: '',
                categoryId: null,
                categoryName: '',
                regionid: null,
                customerdescription: procdureSplit[j],
                cliniciandescription: '',
                cptCode: '',
                icdCode: '',
                cptId: null,
                createdBy: '',
                createdOn: null,
                modifiedBy: '',
                aliasName: '',
                modifiedOn: null,
                procedureName: procdureSplit[j],
                diagnosis: '',
                categoryCodes: null,
                icdCodes: null,
                selected: false
              }

            }
            else {

            }
            if (obj1)
              this.activeProcedures.push(obj1);
            obj1 = null;
            //this.activeProcedures[j].selected = true;
          }
        }


        procdureSplit.forEach(x => {
          var i = 0;
          this.activeProcedures.forEach(y => {
            if (y.customerdescription == x) {
              this.activeProcedures[i].selected = true;
            }
            i = i + 1;
          });
        });
        for (var i = 0; i < procdureSplit.length; i++) {
          procdureSplit[i] = procdureSplit[i].replace(/^\s*/, "").replace(/\s*$/, "");
          this.NewAppointmentForm.patchValue({
            FinanceCenter: procdureSplit,
          });
        }

        //   this.Selectedcode = this.activeProcedures;
        this.bannerService.toggle(this.selectedAppointment.patientId);
        sessionStorage.setItem("patientId", this.selectedAppointment.patientId.toString());
        sessionStorage.setItem("patientName", this.selectedAppointment.name);

        CommonComponents.patientId = this.selectedAppointment.patientId;
        CommonComponents.patientName = this.selectedAppointment.name;
        this.bindAppointmentDetails(this.selectedAppointment);
      });
  }
  customSlotChecked: boolean = false;
  appPhysician = "";
  bindAppointmentDetails(app: IAppointmentData) {
    this.appPhysician = app.physician;
    this.selectedProviderId = app.physician;
    sessionStorage.setItem('appDate', moment(app.start).toDate().toDateString());
    sessionStorage.setItem('providerid', this.selectedProviderId);
    //  var startTime = this.transformTimeFormat(new Date(app.start).getHours(), new Date(app.start).getMinutes());
    this.NewAppointmentForm.patchValue({
      AppointmentDate: moment(app.start).toDate(),
      RenderingProvider: app.physician,
      ServiceSite: app.locationId,
      Room: Number(app.roomId),
      Comments: app.comments,
      SuperVising: app.supervisorProvider,
      PatientName: app.name,
      VisitType: app.visitId.toString(),
      Duration: app.duration,
      StartTime: app.startTime,
      notesComments: app.notesDetails
    });

    if (app.ctdayId == -1) {
      //  this.ReadOnlyCheck =true;
      this.IsSlotfromTemplete = true;
      this.customSlotChecked = true;
      this.NewAppointmentForm.patchValue({
        customchk: true,
      });
    }
    else {
      //   this.ReadOnlyCheck =false;
      this.IsSlotfromTemplete = true;
      this.customSlotChecked = false;
      this.NewAppointmentForm.patchValue({
        customchk: false,
      });
    }
    this.currentAppDate = this.NewAppointmentForm.value.AppointmentDate;
    // if(app.duration != undefined){
    this.slotduration = app.duration;
    // }

    // this.getCalenderByDate(this.currentAppDate);    
    this.getCalenderByDate(this.currentAppDate);
    // this.getlocationbasedproviders();
  }

  public chk: string = "";
  public removechk: string = "";
  selectedProcedures(index, element) {

    var code = element;
    var test = this.Selectedcode.includes(code);
    if (test == true) {
      this.Selectedcode = this.Selectedcode.replace(code, '');
      this.Selectedcode = this.Selectedcode.replace(/##/g, '#');//replace("##", '#');
      this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
      if (this.Selectedcode.charAt(0) == ",") {
        this.Selectedcode = this.Selectedcode.substring(1);
      }
      if (this.Selectedcode.charAt(0) == "#") {
        this.Selectedcode = this.Selectedcode.substring(1);
      }
      if (this.Selectedcode.endsWith("#")) {
        this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
      }
      if (this.Selectedcode == "#") {
        this.Selectedcode = "";
      }
    } else {
      if (this.chk != "") {
        this.Selectedcode = this.Selectedcode.concat("#" + code);
        this.Selectedcode = this.Selectedcode.replace(/##/g, '#');//.replace("##", '#');
        this.Selectedcode = this.Selectedcode.replace(/,\s*$/, "");
        if (this.Selectedcode.charAt(0) == ",") {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
        if (this.Selectedcode.charAt(0) == "#") {
          this.Selectedcode = this.Selectedcode.substring(1);
        }
        if (this.Selectedcode.endsWith("#")) {
          this.Selectedcode = this.Selectedcode.substring(0, this.Selectedcode.length - 1);
        }
        if (this.Selectedcode == "#") {
          this.Selectedcode = "";
        }
      } else {
        this.chk = code;
        this.Selectedcode = code;
        if (this.Selectedcode == "#") {
          this.Selectedcode = "";
        }
      }
    }
    // if (this.Selectedcode.includes("#")) {
    //   for (var i = 0; i < this.Selectedcode.length; i++) {
    //     var character = this.Selectedcode.charAt(i);
    //     if (character == "#") {
    //       this.removechk = this.Selectedcode.replace("#", ",")
    //     }
    //   }
    // }
    this.NewAppointmentForm.controls.FinanceCenter.setValue('');
    this.NewAppointmentForm.patchValue({
      FinanceCenter: this.Selectedcode.replace(/#/g, ',')
    })
  }

  selectedWorkListApp(item: IAppointmentData) {
    if (this.NewAppointmentForm.value.PatientName != "" && this.NewAppointmentForm.value.PatientName != null && this.NewAppointmentForm.value.PatientName != undefined) {
      const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
        width: '450px',
        height: '160px',
        data: { headerText: 'By clicking on OK button, any information that is already entered  will be erased and the appointment details from the worklist will be displayed.' }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result == true) {
          if (item != null && item != undefined) {
            this.selectedAppId = item.Id;
            this.getAppointmentbyId(null);
            this.rescheduleRemarks = 'Rescheduled by Provider';
          }
        }
      });

    }
    else {
      if (item != null && item != undefined) {
        this.selectedAppId = item.Id;
        this.getAppointmentbyId(null);
        this.rescheduleRemarks = 'Rescheduled by Provider';
      }
    }
  }
  selectedProviderList: any = [];
  selectedLocationsList: any = [];
  mySelections: string[];
  onproviderselectionchange(event) {

    this.selectedProviderList = event.selectedOptions.selected.map(item => item.value);
    if (this.selectedProviderList.length < 5) { //this.NewAppointmentForm.value.worklistprovider.length
      if (this.selectedProviderList.length > 1) { // this.NewAppointmentForm.value.worklistprovider.length
        if (this.selectedLocationsList.length > 1) {
          this.selectedLocationsList.length = 1;
          this.NewAppointmentForm.patchValue({
            worklistlocation: this.selectedLocationsList,
          });
        }
      }
      //this.selectedProviderList = this.NewAppointmentForm.value.worklistprovider;
      this.lstProvider.filter(x => x.selected = false) // default set false
      this.lstProvider.filter(x => this.selectedProviderList.includes(x.userId)).map(y => y.selected = true) //set only true
      let csvTL = this.lstProvider.filter(y => y.selected == true).map(y => y.fullName).join(',')// get csv
      this.NewAppointmentForm.patchValue({
        worklistprovider: csvTL // this.selectedProviderList,
      });
    } else {
      this.lstProvider.filter(x => x.selected = false) // default set false
      this.lstProvider.filter(x => this.selectedProviderList.includes(x.userId)).map(y => y.selected = true) //set only true
      let csvTL = this.lstProvider.filter(y => y.selected == true).map(y => y.fullName).join(',')// get csv
      this.NewAppointmentForm.patchValue({
        worklistprovider: csvTL //this.selectedProviderList,
      });
      // this.toastr.warning("Cannot select more than 4 providers");
    }
  }
  // onproviderselectionchange(event) {
  //   if (this.NewAppointmentForm.value.worklistprovider.length < 5) {
  //     if (this.NewAppointmentForm.value.worklistprovider.length > 1) {
  //       if (this.selectedLocationsList.length > 1) {
  //         this.selectedLocationsList.length = 1;
  //         this.NewAppointmentForm.patchValue({
  //           worklistlocation: this.selectedLocationsList,
  //         });
  //       }
  //     }
  //     this.selectedProviderList = this.NewAppointmentForm.value.worklistprovider;
  //   } else {
  //     this.NewAppointmentForm.patchValue({
  //       worklistprovider: this.selectedProviderList,
  //     });
  //     this.toastr.warning("Cannot select more than 4 providers");
  //   }
  // }
  goClick() {
    this.worklistdrp = true;
    this.getBlockedAppointments();
  }
  clear() {
    this.NewAppointmentForm.patchValue({
      worklistlocation: '',
      worklistprovider: '',

    });
  }
  onClickPatientAppointments(): void {
    const dialogRef = this.dialog.open(PatientappointmentsdialogComponent, {
      width: '950px',
      height: '670px',
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  public existList: IAppointmentData[] = []
  data: any[] = [];
  noShowAppointments() {

    // this.show = false;
    this.noShowMessage = '';
    this.existList = this.blockedAppointment.filter(x => x.appStatus === 'NoShow');

    if (this.existList.length > 0) {
      // this.data=this.existList
      this.blockedAppointments = [];
      if (this.existList) {
        for (let i = 0; i < this.existList.length; i++) {
          let v = new BlockedAppointment;
          v.Id = this.existList[i].Id;
          v.patName = this.existList[i].patientName;
          // v.phone = "(" + this.existList[i].homePhone.substring(0, 3) + ") " + this.existList[i].homePhone.substring(3, 6) + "-" + this.existList[i].homePhone.substring(6, 11);//this.existList[i].homePhone;
          v.phone = this.existList[i].homePhone;
          v.physician = this.existList[i].physician;
          v.appDate = formatDate(this.existList[i].start, 'MM/dd/yyyy', 'en-US');
          if (this.existList[i].statusColor && this.existList[i].statusColor != "")
            v.color = this.existList[i].statusColor;
          this.blockedAppointments.push(v);

        }
      }
    }
    else {
      this.blockedAppointments = [];
    }
  }
  public endDate: string;
  onRecentAppointmentsClick() {

    let todayDate = moment(new Date()).toDate();
    todayDate.setDate(todayDate.getDate() - 3).toString();

    this.endDate = todayDate.toString();
    let startDate = new Date();

    // this.show = false;

    this.existList = this.blockedAppointment.filter(x => moment(x.start).toDate() <= moment(startDate).toDate() && moment(x.start).toDate() >= moment(this.endDate).toDate());

    if (this.existList.length == 0) {
      this.noShowMessage = 'No Result Found.'
    } else {
      this.noShowMessage = '';
    }
    if (this.existList.length > 0) {
      // this.data=this.existList
      this.blockedAppointments = [];
      if (this.existList) {
        for (let i = 0; i < this.existList.length; i++) {
          let v = new BlockedAppointment;
          v.Id = this.existList[i].Id;
          v.patName = this.existList[i].patientName;
          // v.phone = "(" + this.existList[i].homePhone.substring(0, 3) + ") " + this.existList[i].homePhone.substring(3, 6) + "-" + this.existList[i].homePhone.substring(6, 11);//this.existList[i].homePhone;
          v.phone = this.existList[i].homePhone;
          v.physician = this.existList[i].physician;
          v.appDate = formatDate(this.existList[i].start, 'MM/dd/yyyy', 'en-US');
          if (this.existList[i].statusColor && this.existList[i].statusColor != "")
            v.color = this.existList[i].statusColor;
          this.blockedAppointments.push(v);

        }
      }
    } else {
      this.blockedAppointments = [];
    }
  }

  onRefreshClick() {

    this.worklistdrp = false;
    this.getBlockedAppointments();
    //this.show = !this.show;
    this.show = false;
    this.clear();
  }
  onSelect(event) {
    if (event.currDate != null && event.currDate != undefined) {

      this.currentAppDate = event.currDate;
      this.getCalenderByDate(this.currentAppDate);
      this.calendarHeaderDate = this.datePipe.transform(event.currDate, "yyyy-MM-dd");
      // this.NewAppointmentForm.patchValue({
      //   AppointmentDate: event.currDate,
      //   VisitType: '',
      //   Duration: '',
      //   StartTime: null,
      // });
    }
  }

  clearVisit() {

    this.availableSlotsList = [];
    this.availableSlot = [];
    this.selectedctdayId = 0;
    this.NewAppointmentForm.patchValue({
      VisitType: '',
      // Duration: '',
      StartTime: null
      // Room:''
    });

  }
  cleartime() {
    this.selectedctdayId = 0;
    this.NewAppointmentForm.patchValue({
      //  Duration: '',
      StartTime: null,
      customchk: false,
    });
    this.customSlotChecked = false;

  }

  ApptWorklist: IExportexcelWorklist[] = [];
  fileName = 'Appointment Worklist.xlsx';
  ondOownLoadFile(fileFormat: string) {

    switch (fileFormat) {
      case 'CSV':
        const options = {
          fieldSeparator: ',',
          quoteStrings: '"',
          decimalSeparator: '.',
          showLabels: true,
          useTextFile: false,
          showTitle: true,
          title: 'Appointment Worklist',
          useBom: true,
          useKeysAsHeaders: true,
        };
        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(this.ApptWorklist);
        return false;

      case 'XLS':
        let binaryWS = XLSX.utils.json_to_sheet(this.ApptWorklist);
        // Create a new Workbook
        var wb = XLSX.utils.book_new();
        // Name your sheet
        XLSX.utils.book_append_sheet(wb, binaryWS, 'Appointment Worklist')
        // export your excel
        XLSX.writeFile(wb, this.fileName);
        //   let el = document.getElementById("Auditlogs");
        //  // let element = this.Auditlogs;//.nativeElement;
        //   const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(el.innerText);
        //   /* generate workbook and add the worksheet */
        //   const wb: XLSX.WorkBook = XLSX.utils.book_new();
        //   XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
        //   /* save to file */  
        //   XLSX.writeFile(wb, this.fileName);
        return false;

      // case 'PDF':
      //   // let data = document.getElementById('divId');  
      //   // html2canvas(data).then(canvas => {
      //   // const contentDataURL = canvas.toDataURL('image/png')  
      //   // let pdf = new jspdf('l', 'cm', 'a4'); //Generates PDF in landscape mode
      //   // // let pdf = new jspdf('p', 'cm', 'a4'); Generates PDF in portrait mode
      //   // pdf.addImage(contentDataURL, 'PNG', 0, 0, 29.7, 21.0);  
      //   // pdf.save('Filename.pdf'); 
      //   return false;
    }
  }

  getRoomsbyLocation() {

    let locId: any;
    locId = this.NewAppointmentForm.value.ServiceSite;
    if (locId == null || locId == undefined || locId == '')
      locId = sessionStorage.getItem("LocationId");
    this.schedulerservice.getRooms(locId).subscribe(data => {
      this.lstRooms = data;
      this.lstRooms = this.lstRooms.filter(x => x.isActive === true);
      // this.NewAppointmentForm.patchValue(
      //   {
      //     Room:''
      //   }
      // )
    });


  }

  OpenProcedures() {
    const dialogRef = this.dialog.open(ProceduresDialogComponent, {
      width: '1200px',
      height: 'auto',
      data: { headerText: 'Add New Patient Procedures', notesType: 0 }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
        if (result.procedureName !== '' && result.procedureName !== undefined && result.procedureName !== null) {
          var selectedproced = ((result.procType == null ? "" : result.procType + " ") + result.procedureName + ((result.procSide == null || result.procSide == '') ? "" : "(" + result.procSide + ")")
            + ((result.procLevels == null || result.procLevels == '') ? "" : "(" + result.procLevels + ")"));
          var sepListProduce = this.activeProcedures.filter(x => x.customerdescription == selectedproced);
          if (sepListProduce.length > 0) {
            var selectedProcedures = this.NewAppointmentForm.value.FinanceCenter;
            if (selectedProcedures !== undefined && selectedProcedures !== null) {
              if (selectedProcedures.length > 0) {
                // selectedProcedures.push(result.procedureName);
                // this.NewAppointmentForm.patchValue({
                //   FinanceCenter: selectedProcedures,
                // });
              }
            } else {
              // this.NewAppointmentForm.patchValue({
              //   FinanceCenter: result.procedureName.toArray(),
              // });
            }
          } else {
            var tempProcude: IprocedureCode = new IprocedureCode();
            tempProcude.customerdescription = ((result.procType == null ? "" : result.procType + " ") + result.procedureName + ((result.procSide == null || result.procSide == '') ? "" : "(" + result.procSide + ")")
              + ((result.procLevels == null || result.procLevels == '') ? "" : "(" + result.procLevels + ")"));
            this.activeProcedures.push(tempProcude);

            // var selectedProcedures = this.NewAppointmentForm.value.FinanceCenter;
            // if (selectedProcedures !== undefined && selectedProcedures !== null) {
            //   if (selectedProcedures.length > 0) {
            //     selectedProcedures.push(result.procedureName);
            //     this.NewAppointmentForm.patchValue({
            //       FinanceCenter: selectedProcedures,
            //     });
            //   }
            // } else {
            //   this.NewAppointmentForm.patchValue({
            //     FinanceCenter: result.procedureName.toArray(),
            //   });
            // }
          }
        }
      }
    });
  }

  personalInfo: IPersonalInfo;
  patEmailId: string = '';
  patCellPhone: string = "";
  getPeresonalInfo(id: number) {
    this.personalService.getPersonalInfo(id)
      .subscribe(
        (personal: IPersonalInfo) => {
          this.personalInfo = personal;
          this.patEmailId = this.personalInfo.currentAddressDetails.emailId;
          this.patCellPhone = this.personalInfo.currentAddressDetails.cellPhone;
        },
        (err: any) => console.log(err)
      );
  }
  focusOutFunctionprocedure(evn) {
    if (evn.keyCode === 9) {
      $('#procedurefocushide').hide()
    } else if (evn.keyCode === 40 && evn.target.id == "procedurefocus") {
      $('#procedureistoption0').focus();
    }
  }
  focusOutFunctionproviders(evn) {

    if (evn.keyCode === 9) {
      $('#providersfocushide').hide()
    } else if (evn.keyCode === 40 && evn.target.id == "providersfocus") {
      $('#providerslistoption0').focus();
    }
  }
  IsProvider: boolean = false;
  IsNurse: boolean = false;
  getProviderRole() {
    this.IsProvider = false;
    this.IsNurse = false;
    if (sessionStorage.getItem("role") == "Doctor") {
      this.IsProvider = true;
      this.IsNurse = false;
    }
    else if (sessionStorage.getItem("role") == "Nurse") {
      this.IsProvider = false;
      this.IsNurse = true;
    }
  }
  clearFieldsAfterSubmit() {

    this.initilizeCalender();
    this.NewAppointmentForm.patchValue({
      VisitType: '',
      StartTime: null,
      Duration: '',
      customchk: false,
      Room: '',
      Comments: '',
      SuperVising: '',
      notesComments: '',
      FinanceCenter: '',
    });
    this.Selectedcode = '';
    this.chk = '';
    this.activeProcedures.forEach(d => {
      d.selected = false
    })
    this.getCalenderByDate(this.NewAppointmentForm.value.AppointmentDate);
    this.calendarHeaderDate = this.datePipe.transform(this.NewAppointmentForm.value.AppointmentDate, "yyyy-MM-dd");
    this.availableSlotsList = [];
    this.availableSlot = [];
    this.selectedctdayId = 0;
    //this.show = true;
    this.IsFollowupCreateApp = false;
    this.onRefreshClick();
  }
  DisplayCurrentTime(_date: Date) {

    var hours: any = _date.getHours() > 12 ? _date.getHours() - 12 : _date.getHours();
    var am_pm = _date.getHours() >= 12 ? "PM" : "AM";
    hours = hours < 10 ? "0" + hours : hours;
    var minutes = _date.getMinutes() < 10 ? "0" + _date.getMinutes() : _date.getMinutes();
    // var seconds = _date.getSeconds() < 10 ? "0" + _date.getSeconds() : _date.getSeconds();
    var time: any = hours + ":" + minutes + " " + am_pm;
    return time;
  };
  createTimeSlots(startHour: Date, endHour: Date, interval: number) {
    var timeSlots = []
    var _startdatefrom = startHour;
    var _enddateTo = endHour;

    timeSlots.push({ value: this.DisplayCurrentTime(_startdatefrom), viewValue: this.DisplayCurrentTime(_startdatefrom) });
    while (_startdatefrom < _enddateTo) {

      _startdatefrom = moment(_startdatefrom).add(interval, 'm').toDate();
      timeSlots.push({ value: this.DisplayCurrentTime(_startdatefrom), viewValue: this.DisplayCurrentTime(_startdatefrom) });
    }
    //timeSlots.pop();
    return timeSlots;
  }
  // createTimeSlots(startHour, endHour, interval) {
  //   if (!startHour) {
  //     endHour = 8;
  //   }
  //   if (!endHour) {
  //     endHour = 20;
  //   }
  //   var timeSlots = [],
  //     dateTime = new Date(),
  //     timeStr = '';
  //   dateTime.setHours(startHour, 0, 0, 0);
  //   timeStr = dateTime.getHours() + ':' + dateTime.getMinutes();
  //   while (new Date(dateTime.getTime() + interval * 60000).getHours() < endHour) {
  //     if (timeSlots.length == 0) {
  //       timeStr = this.getTimeformat(this.transform(dateTime.toDateString()) + " " + timeStr);
  //       timeSlots.push({ value: timeStr, viewValue: timeStr });
  //     }
  //     dateTime = new Date(dateTime.getTime() + interval * 60000);
  //     timeStr = dateTime.getHours() + ':' + dateTime.getMinutes();
  //     timeStr = this.getTimeformat(this.transform(dateTime.toDateString()) + " " + timeStr);
  //     timeSlots.push({ value: timeStr, viewValue: timeStr });
  //   }
  //   dateTime.setHours(endHour, 0, 0, 0);
  //   timeStr = dateTime.getHours() + ':' + dateTime.getMinutes();
  //   timeStr = this.getTimeformat(this.transform(dateTime.toDateString()) + " " + timeStr);
  //   timeSlots.push({ value: timeStr, viewValue: timeStr });
  //   return timeSlots;
  // }

  getTimeformat(value: string): string {
    if (value && value != undefined) {
      var datePipe = new DatePipe("en-US");
      value = datePipe.transform(value, 'hh:mm a');
    }
    return value;
  }

  public IsFollowupCreateApp: boolean = false;
  createFromfollowUp() {
    this.IsFollowupCreateApp = true;
    this.onSubmit(true);
  }
}

